window.refreshReportProcedureCombination = function() {
    ReportSharedFunctions.InitReportPage();

    if (!Model.Validated)
        window.addLocks(new URLSearchParams(window.location.search).get('fc') * 1, lockUIDs);

    ReportSharedFunctions.ShowUnknownWordsFoundMessageIfThereAreAny(Model.AmountOfWordsToReviewForUser);

    if(bulkDictation)
    {
        $('#loading').hide();

        let goToOtherOrderInBulkResource;

        if (dictatedBy == null || dictatedBy == '') {
            goToOtherOrderInBulkResource = window.Resources.GoToOtherOrderInBulk;
        } else {
            goToOtherOrderInBulkResource = window.Resources.GoToOtherOrderInBulkValidation;
        }

        $('#confirmSkipToOtherBulkReport').dialog({
            autoOpen: false,
            resizable: false,
            modal: true,
            appendTo: '#contentView',
            position: { my: "right top", at: "right-15 top+30", of: '#contentView' },
            title: htmlDecode(goToOtherOrderInBulkResource)
        });

        $.each($('.transformToCalendar'), function (i, y) {
            var m = moment($(y).text(), "MM/DD/YYYY hh:mm:ss A");
            if (m != null && m.isValid) {
                $(y).text(htmlDecode(m.calendar()));
            }
        });
    }

    if(!screening)
    {
        const SetPreviousContent = (e) => {
            const previousContent = $('textarea#ReportContent').attr('value');
            tinymce.activeEditor.setContent(previousContent);
            tinymce.activeEditor.focus();
        }

        $('#loading').hide();

        //Initial setup editor
        if ($('div#divOrderReport').length > 0) {
            ReportSharedFunctions.InitTextEditor(Model);
        }

        $('li#openReportTab').on('click', function (e) {
            SetPreviousContent();
        });
    }
    else
    {
        if (!Model.Validated && !Model.ReadOnly)
        {
            $('#request li.letter').removeClass('disabled');
            EditMode = true;
            if (Model.RequestFormInformation.PatientHasInvitationWith)
            {
                $('#request #ReferringPhysicianText').prop('disabled', true);
                $('#request #ReferringPhysicianText').css('background-color', '#EEE');
                $("#request #referringPhysActionMenu").menu("option", "disabled", true);
            }
        }
    }
    window.reportGUID = Model.GUID;

    var checkModels = [];
    var gValidated;
    var gTranscription;
    var gPreliminary;
    var gTriggerExportFormats;
    var gClose;
    var gSupervisor_uid;
    var gReviewer_uid;

    var procedureToRemoveFromReport = undefined;
    var procedureToAddToReport = undefined;

    $('.validation').hide();
    $('.required').hide();

    $('#divPopupPreviousReport' + viewbagUniquePrefix).dialog({
        autoOpen: false,
        resizable: false,
        modal: false,
        appendTo: '#contentView',
        position: { my: "right top", at: "right-25 top+125", of: '#contentView' },
        //position:  { my: "center", at: "center", of: $("#subPageContent") },
        close: function (event, ui) {
            tinymce.activeEditor.focus();
        }
    });

    $('#dialogConfirmRemoveProcedure').dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        appendTo: "#contentView",
        position: { my: "right top", at: "right-15 top+30", of: '#contentView' },
        title: htmlDecode(window.Resources.RemoveFromThisReport)
    });

    $('#dialogConfirmAddProcedure').dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        appendTo: '#contentView',
        position: { my: "right top", at: "right-15 top+30", of: '#contentView' },
        title: htmlDecode(window.Resources.AddToThisReport)
    });

    $('#divDevalidateScreening').dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        appendTo: '#contentView',
        position: { my: "center", at: "center", of: '#contentView' },
        title: htmlDecode(window.Resources.Warning)
    });

    $('#dialogPrivateRemarks' + viewbagUniquePrefix).dialog({
        autoOpen: false,
        resizable: false,
        modal: false,
        position: { my: "right top", at: "right-15 top+30", of: '#contentView' },
        appendTo: "#contentView",
        dialogClass: "innerDialog",
        title: $("<div/>").html(window.Resources.PrivateRemarks).text(),
        close: function (e, ui) {
            $('dd#privateRemarksShow').removeClass('open');
            $('dd#privateRemarksShow').text(window.Resources.ClickToOpen + '...');
        }
    });

    $('#divPopupConfirmation' + viewbagUniquePrefix).dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        appendTo: "#contentView",
        position: { my: "right top", at: "right-15 top+30", of: '#contentView' }
    });

    $('#divViewReportDialog' + viewbagUniquePrefix).dialog({
        autoOpen: false,
        resizable: false,
        modal: false,
        draggable: true,
        appendTo: "#contentView",
        title: $("<div/>").html(window.Resources.Preview + ' ' + window.Resources.Report).text(),
        position: { my: "right top", at: "right-15 top+30", of: '#contentView' },
        sticky: 'false'
    });

    $('#divSetCheckedBy').dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        appendTo: '#divPopupConfirmationChecksRemaining',
        dialogClass: 'divSetCheckedBy',
        position: { my: "center top", at: "center top+5", of: $('#divPopupConfirmationChecksRemaining') },
        title: $("<div/>").html(window.Resources.select + ' ' + window.Resources.User).text(),
        close: function () {
            if (!window.ChecksDialog.leavechecked) {
                var forcheck = $('#forCheckSetBy').val();
                $('tr.record' + forcheck + ' input.checkChecked').attr('checked', '');
                $('tr.record' + forcheck + ' input.checkChecked').prop('checked', false);
                $('tr.record' + forcheck + ' input.checkChecked').val(false);
            }
        }
    });

    $('#dialogPublicRemarks' + viewbagUniquePrefix).dialog({
        autoOpen: false,
        resizable: false,
        modal: false,
        position: { my: "right top", at: "right-15 top+30", of: '#contentView' },
        appendTo: "#contentView",
        dialogClass: "innerDialog",
        title: $("<div/>").html(window.Resources.PublicRemarks).text(),
        close: function (e, ui) {
            $('dd#publicRemarksShow').removeClass('open');
            $('dd#publicRemarksShow').text(window.Resources.ClickToOpen + '...');
        }
    });

    $('#divSetRemarks').dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        appendTo: '#contentView',
        title: $("<div/>").html(window.Resources.Add + ' ' + window.Resources.Remarks).text()
    });

    $('#dialogReloadProcCombFile').dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        appendTo: '#contentView',
        position: { my: "right top", at: "right-15 top+30", of: '#contentView' },
        title: htmlDecode(window.Resources.ReloadFile)
    });

    $('#divPopupConfirmationEmpty').dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        appendTo: '#contentView',
        position: { my: "center", at: "center", of: '#contentView' },
        title: htmlDecode(window.Resources.EmptyReport)
    });

    $('#btnConfirmRemoveProcedureCancel').on('click', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        $('#dialogConfirmRemoveProcedure').dialog('close');
    });

    $('#btnConfirmAddProcedureCancel').on('click', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        $('#dialogConfirmAddProcedure').dialog('close');
    });
    
    function RemoveOrderProcedureFromReport(orderProcedureUID) {
        $('#procNotInReport li.procedureReportTitle.none').hide();
        procedureToRemoveFromReport.find('span.procHasReport').remove();
        procedureToRemoveFromReport.clone().appendTo('#procNotInReport');
        procedureToRemoveFromReport.remove();

        forOrder_ProcedureUIDs = forOrder_ProcedureUIDs.replace(orderProcedureUID + "_", "");
        if (addOrder_ProcedureUIDs.indexOf("|" + orderProcedureUID + "|_") < 0) {
            removeOrder_ProcedureUIDs += "|" + orderProcedureUID + "|_";
            createCookie('removeOrder_ProcedureUIDs' + viewbagUniquePrefix, removeOrder_ProcedureUIDs, 7);
        }
        addOrder_ProcedureUIDs = addOrder_ProcedureUIDs.replace("|" + orderProcedureUID + "|_", "");
        createCookie('addOrder_ProcedureUIDs' + viewbagUniquePrefix, addOrder_ProcedureUIDs, 7);

        $('#dialogConfirmRemoveProcedure').dialog('close');

        if (UseImpax6Integration) {
            LaunchImpax6IntegrationAfterAddingOrRemovingProcedures(forOrder_ProcedureUIDs, true);
        }

        $('.procedureItem, .procedureItemWithRating, .procedureItemWithRatingv1').tooltip({
            tooltipClass: 'jqueryTooltip',
            //track: true,
            content: function () {
                return $(this).prop('title');
            },
            position: {
                my: "left top",
                at: "left bottom"
            },
            close: function (event, ui) {
                $('.jqueryTooltip').remove();
            },
            show: function (event, ui) {
                $('.jqueryTooltip').remove();
            }
        });
    };


    $('#btnConfirmRemoveProcedureOk').on('click', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();

        var orderProcedureUID = procedureToRemoveFromReport.find('.number').text();

        //if (!dictatedReport) {
        var currentLockedRecordID = $('span#lockableRecordID').text();
        ReportSharedFunctions.RemoveOrderProcedureFromLock(orderProcedureUID).done(function (e) {
            $('span#lockableRecordID').text(currentLockedRecordID.replace("|" + orderProcedureUID + "|_", ""));
            RemoveOrderProcedureFromReport(orderProcedureUID);
        });
    });

    function AddOrderProcedureToReport(orderProcedureUID) {

        procedureToAddToReport.clone().appendTo('#procInReport');
        procedureToAddToReport.remove();

        if ($('#procNotInReport li.procedureItem, #procNotInReport li.procedureItemWithRating, #procNotInReport li.procedureItemWithRatingv1').length == 0) {
            $('#procNotInReport').append('<li style="font-weight: bold;" class="procedureReportTitle none">' + window.Resources.None + '</li>');
        }

        forOrder_ProcedureUIDs += orderProcedureUID + "_";
        addOrder_ProcedureUIDs += "|" + orderProcedureUID + "|_";
        removeOrder_ProcedureUIDs = removeOrder_ProcedureUIDs.replace("|" + orderProcedureUID + "|_", "");

        createCookie('addOrder_ProcedureUIDs' + viewbagUniquePrefix, addOrder_ProcedureUIDs, 7);
        createCookie('removeOrder_ProcedureUIDs' + viewbagUniquePrefix, removeOrder_ProcedureUIDs, 7);

        $('#dialogConfirmAddProcedure').dialog('close');

        if (UseImpax6Integration) {
            LaunchImpax6IntegrationAfterAddingOrRemovingProcedures(forOrder_ProcedureUIDs, false);
        }

        $('.procedureItem, .procedureItemWithRating, .procedureItemWithRatingv1').tooltip({
            tooltipClass: 'jqueryTooltip',
            //track: true,
            content: function () {
                return $(this).prop('title');
            },
            position: {
                my: "left top",
                at: "left bottom"
            },
            close: function (event, ui) {
                $('.jqueryTooltip').remove();
            },
            show: function (event, ui) {
                $('.jqueryTooltip').remove();
            }
        });
    };

    function responseAddOPToLockSuccess (currentLockedRecordID, orderProcedureUID) {
        $('span#lockableRecordID').text(currentLockedRecordID + "|" + orderProcedureUID + "|_");
        AddOrderProcedureToReport(orderProcedureUID);
    }

    $('#btnConfirmAddProcedureOk').on('click', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();

        var orderProcedureUID = procedureToAddToReport.find('.number').text();
        var currentLockedRecordID = $('span#lockableRecordID').text();
        var resReqAddToLock = AddOrderProcedureToLock(orderProcedureUID).done(function (e) {
            const fc = new URLSearchParams(window.location.search).get('fc') * 1;
            window.addLocks(fc, e.Locks.LockUIDs);
            if (resReqAddToLock.responseJSON && !resReqAddToLock.responseJSON.Locks.NewLock)
                window.showLockedFileDialog(resReqAddToLock.responseJSON, null, responseAddOPToLockSuccess.bind(this, currentLockedRecordID, orderProcedureUID));
            else
                responseAddOPToLockSuccess(currentLockedRecordID, orderProcedureUID);
        });
    });

    $.contextMenu("destroy",{selector: 'ul#procInReport li.procedureItem, ul#procInReport li.procedureItemWithRating, ul#procInReport li.procedureItemWithRatingv1' });
    $.contextMenu({
        selector: 'ul#procInReport li.procedureItem, ul#procInReport li.procedureItemWithRating, ul#procInReport li.procedureItemWithRatingv1',
        events: {
            show: function (opt) {
                if ($('ul#procInReport li.procedureItem, ul#procInReport li.procedureItemWithRating, ul#procInReport li.procedureItemWithRatingv1').length <= 1 || validatedReport || readOnly) {
                    return false;
                }
                else {
                    procedureToRemoveFromReport = $(this);
                }
            }
        },
        build: function ($trigger, e) {
            return {
                callback: function (key, options) {
                    if (key == "remove") {
                        var procedureClone = procedureToRemoveFromReport.clone();
                        $('#confirmRemoveProcedureHolder').empty();
                        procedureClone.appendTo('#confirmRemoveProcedureHolder');

                        $('.procedureItem, .procedureItemWithRating, .procedureItemWithRatingv1').tooltip({
                            tooltipClass: 'jqueryTooltip',
                            //track: true,
                            content: function () {
                                return $(this).prop('title');
                            },
                            position: {
                                my: "left top",
                                at: "left bottom"
                            },
                            close: function (event, ui) {
                                $('.jqueryTooltip').remove();
                            },
                            show: function (event, ui) {
                                $('.jqueryTooltip').remove();
                            }
                        });

                        $('#dialogConfirmRemoveProcedure').dialog('open');
                    }
                },
                items: {
                    "remove": {
                        name: window.Resources.RemoveFromThisReport,
                        disabled: function () {
                            if ($('ul#procInReport li.procedureItem, ul#procInReport li.procedureItemWithRating, ul#procInReport li.procedureItemWithRatingv1').length <= 1 || validatedReport || readOnly) {
                                return true;
                            }
                            return false;
                        }
                    }
                }
            }
        }
    });

    $.contextMenu("destroy",{selector: 'ul#procNotInReport li.procedureItem, ul#procNotInReport li.procedureItemWithRating, ul#procNotInReport li.procedureItemWithRatingv1' });
    $.contextMenu({
        selector: 'ul#procNotInReport li.procedureItem, ul#procNotInReport li.procedureItemWithRating, ul#procNotInReport li.procedureItemWithRatingv1',
        events: {
            show: function (opt) {
                if ($(this).find('.procIsLocked').length > 0 || $(this).find('.procIsValidated').length > 0 || $(this).find('.procIsDictated').length > 0 || validatedReport || readOnly) {
                    return false;
                }
                else {
                    procedureToAddToReport = $(this);
                }
            }
        },
        build: function ($trigger, e) {
            return {
                callback: function (key, options) {
                    if (key == "add") {
                        var procedureClone = procedureToAddToReport.clone();
                        $('#confirmAddProcedureHolder').empty();
                        procedureClone.appendTo('#confirmAddProcedureHolder');

                        $('.procedureItem, .procedureItemWithRating, .procedureItemWithRatingv1').tooltip({
                            tooltipClass: 'jqueryTooltip',
                            //track: true,
                            content: function () {
                                return $(this).prop('title');
                            },
                            position: {
                                my: "left top",
                                at: "left bottom"
                            },
                            close: function (event, ui) {
                                $('.jqueryTooltip').remove();
                            },
                            show: function (event, ui) {
                                $('.jqueryTooltip').remove();
                            }
                        });

                        $('#dialogConfirmAddProcedure').dialog('open');
                    }
                },
                items: {
                    "add": {
                        name: window.Resources.AddToThisReport,
                        disabled: function () {
                            if ($(this).find('.procIsLocked').length > 0 || $(this).find('.procIsValidated').length > 0 || $(this).find('.procIsDictated').length > 0 || validatedReport || readOnly) {
                                return true;
                            }
                            return false;
                        }
                    }
                }
            }
        }
    });

    function NoOrderHistory(e) {
        var divNoTimeLine = '<div id="noOrderHistoryTimeline">' + window.Resources.NoOrderHistoryFound + '</div>';
        $('div#submitBottom').prepend(divNoTimeLine);
    }
    var scrollingOverOrders = false;

    var CheckedFilterModality = filterReportHistoryModality;
    var CheckedFilterProcedures = filterReportHistoryProcedures;

    function SetOrderHistory(e) {
        var divTimeLine = '<div id="orderHistoryTimeline">';
        divTimeLine += '<div class="timelineContainer" id="orderHistoryContainer"><ul class="timelineList" id="orderHistoryList"></ul></div>';
        divTimeLine += '<div class="timelineContainer" id="yearHistoryContainer"><ul class="timelineList" id="yearHistoryList"></ul></div>';
        divTimeLine += '</div>';
        $('div#submitBottom').prepend(divTimeLine);

        var amountInWidth = $('.timelineContainer').width() / 200;

        $.each(orderHistory.Items, function (i, x) {
            var toAppend = '<li class="timelineItem ' + x.Year + '">';
            toAppend += '<ul>';
            $.each(x.OrderProcedures, function (i, proc) {
                toAppend += '<li class="procedureItem ' + (proc.StatusIndicator == 5 ? "controlProcedure" : (proc.StatusIndicator == 1 ? "startedProcedure" : (proc.StatusIndicator == 2 ? "finishedProcedure" : (proc.StatusIndicator == 3 ? "correctionProcedure" : (proc.StatusIndicator == 4 ? "canceledProcedure" : ""))))) + '" style="background-color: ' + proc.Color + '"';
                toAppend += ' title="' + proc.Modality_Text + ' - ' + proc.Description + '<br>' + proc.Room_Text + ' - <b>' + proc.Radiologist_Text + '</b>">';
                toAppend += '<span class="hidden number">' + proc.OrderHasProcedure_UID + '</span>';
                if (proc.Report_UID != 0 && proc.Report_UID != null) {
                    toAppend += '<span class="procedureReportUID hidden">' + proc.Report_UID + '</span>';
                }
                toAppend += '<span class="insideProcedureItemContainer"><b>' + proc.Modality_Text + '</b> ' + proc.Code + '</span>';
                if (proc.Validated) {
                    toAppend += '<span class="procHasReport" title=window.Resources.Validated>V</span>';
                }
                else if (proc.Dictated) {
                    toAppend += '<span class="procHasReport" title=window.Resources.Dictated>D</span>';
                }
                toAppend += '</li>';
            });
            toAppend += '</ul>';
            toAppend += '<span class="hidden orderID">' + x.Order_UID + '</span>';
            toAppend += "<span class='date'>(" + x.DateTime + ")</span>";
            toAppend += "<span class='titlePopup hidden'>" + x.Title + " (" + x.DateTime + ")</span>";
            if (x.HasReport == true) {
                toAppend += '<span class="hidden orderReportID">' + x.Report_UID + '</span>';
            }
            toAppend += '</li>';
            $('ul#orderHistoryList').append(toAppend);

            $('.procedureItem, .procedureItemWithRating, .procedureItemWithRatingv1').tooltip({
                tooltipClass: 'jqueryTooltip',
                //track: true,
                content: function () {
                    return $(this).prop('title');
                },
                position: {
                    my: "left top",
                    at: "left bottom"
                },
                close: function (event, ui) {
                    $('.jqueryTooltip').remove();
                },
                show: function (event, ui) {
                    $('.jqueryTooltip').remove();
                }
            });
        });

        var totalWidth = 0;
        $.each($('ul#orderHistoryList li.timelineItem'), function (i, y) {
            totalWidth += $(this).outerWidth();
            if (i == $('ul#orderHistoryList li.timelineItem').length - 1) {
                totalWidth += $('div#orderHistoryContainer').width() - $(this).outerWidth();
            }
        });

        $('#orderHistoryList').css('width', totalWidth);

        var checkModality = '<li class="filterHistory">';
        checkModality += '<input type="checkbox" id="checkModality" class="check-box" ' + (CheckedFilterModality ? 'checked="true"' : '') + ' /><span>' + $('<div/>').html(window.Resources.SameModality).text() + '</span></li>';
        $('ul#yearHistoryList').append(checkModality);

        var checkProcedures = '<li class="filterHistory">';
        checkProcedures += '<input type="checkbox" id="checkProcedures" class="check-box" ' + (CheckedFilterProcedures ? 'checked="true"' : '') + ' /><span>' + $('<div/>').html(window.Resources.SameProcedures).text() + '</span></li>';
        $('ul#yearHistoryList').append(checkProcedures);

        $.each(orderHistory.OrdersInYears, function (i, x) {
            var toAppend = '<li class="yearItem">';
            if (x.Amount != x.OriginalAmount) {
                toAppend += '<span class="title">' + x.Year + '</span><span class="amount">&nbsp;(' + x.Amount + ' ' + $("<div/>").html(window.Resources.of).text() + ' ' + x.OriginalAmount + ')</span>';
            }
            else {
                toAppend += '<span class="title">' + x.Year + '</span><span class="amount">&nbsp;(' + x.Amount + ')</span>';
            }
            $('ul#yearHistoryList').append(toAppend);
        });

        $("#orderHistoryContainer").mCustomScrollbar({
            horizontalScroll: true,
            theme: "dark",
            scrollButtons: {
                enable: true
            },
            mouseWheelPixels: 180,
            advanced: {
                updateOnBrowserResize: true,
                autoExpandHorizontalScroll: true
            }
        });

        $('#yearHistoryList').css('width', (150 * (orderHistory.OrdersInYears.length)) + 2 + "px");


        $('li.timelineItem ul li').hoverIntent(
            {
                sensitivity: 3,
                interval: 200,
                timeout: 200,
                over: function (e) {
                    e.stopImmediatePropagation();
                    if (!scrollingOverOrders) {
                        var titlePopup;
                        var reportID;

                        var procedureReportUID = $(this).find('span.procedureReportUID').text();
                        titlePopup = $(this).find('.insideProcedureItemContainer').text() + ' ' + $(this).parent().parent().find('span.date').text();
                        ReportSharedFunctions.ShowPreviousReportPopup(procedureReportUID, titlePopup, viewbagUniquePrefix, screening, false);

                        tinymce.activeEditor.focus();
                    }
                },
                out: function (e) { }
            }
        );
    }

    var orderHistory;
    var orderHistoryFound = false;

    function OrderHistoryCall(e) {
        var req = $.ajax({
            type: 'GET',
            data: {
                Patient_UID: Model.PatientID,
                Order_UID: Model.OrderID,
                CheckedFilterModality: CheckedFilterModality,
                CheckedFilterProcedure: CheckedFilterProcedures,
                Partial: true,
                PartialReport_UID: viewbagreport_UID,
                PartialProcedure_IDs: forOrder_ProcedureUIDs
            },
            url: '/legacy/Reports/GetOrderHistoryTimeLine',
            dataType: 'json'
        });

        return req;
    };

    function GetOrderHistory(e) {
        orderHistory = null;
        orderHistoryFound = false;
        $('ul#orderHistoryList').hide();
        var loader = $('<div><img src="/Content/img/loading.gif"/></div>');
        $('div#orderHistoryContainer').prepend(loader);

        var historyErrors = false;

        var reqHis = OrderHistoryCall().done(function () {
            if (reqHis.responseJSON.AllOk) {
                orderHistoryFound = true;
                orderHistory = reqHis.responseJSON.OrderHistory;
            }
            else {
                historyErrors = true;
            }

            if (orderHistoryFound) {
                $('#orderHistoryTimeline').remove();

                if (historyErrors) {
                    NoOrderHistory();
                }
                else {
                    SetOrderHistory();
                }
            }
            else {
                NoOrderHistory();
            }
            $('ul#orderHistoryList').show();
            ResizeOrderReportFields();
        });
    }

    $('#reloadPage').on('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        $('#dialogReloadProcCombFile').dialog('open');
    });

    $('#btnOkReloadProcCombFileDialog').on('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        $('#dialogReloadProcCombFile').dialog('close');

        ReportSharedFunctions.OnReloadRemoveAddedProceduresInReport();

        ReportSharedFunctions.LaunchEmptyPacsIntegration();
        closeActiveFile(false);
    });

    $('#btnCloseReloadProcCombFileDialog').on('click', function (e) {
        $('#dialogReloadProcCombFile').dialog('close');
    });

    $('.procedureItem, .procedureItemWithRating, .procedureItemWithRatingv1').tooltip({
        tooltipClass: 'jqueryTooltip',
        //track: true,
        content: function () {
            return $(this).prop('title');
        },
        position: {
            my: "left top",
            at: "left bottom"
        },
        close: function (event, ui) {
            $('.jqueryTooltip').remove();
        },
        show: function (event, ui) {
            $('.jqueryTooltip').remove();
        }
    });

    $('.infoHoverPopup').hide();

    $('#submitBottom span.datetime').each(function (i, y) {
        var unformattedModDate = $(this).html();
        var m = moment(unformattedModDate, "MM/DD/YYYY hh:mm:ss A");
        if (m.isValid()) {
            $(this).html(m.calendar());
        }
    });

    var $tabs = $("#tabs").tabs();

    $('textarea#ReportContent').autosize();

    $('input#btnCloseFile').on('click', function (e) {
        $('body').off('click', 'ul.listFound li');
        ReportSharedFunctions.LaunchEmptyPacsIntegration();
        ReportSharedFunctions.SendORUOnClose(forOrder_ProcedureUIDs);
        closeActiveFile(true);
    });

    $('input#btnSkipFile').on('click', function (e)
    {
        if(userHasSpeechRecognition && useG2Speech)
            clearTimeout(window.pollG2Timeout);

        closeActiveSpeech().done(function ()
        {
            const isToDictate = dictatedBy == null || dictatedBy == '';
            if (isToDictate) {
                const resReq = setOrderAsSkippedInBulkSession(Model.OrderID, isToDictate ? 1 : 2).done(function (e) {
                    if (resReq.responseJSON.AllOk) {
                        const resNextOrderBulk = getNextOrderToBulkDictate(null).done(function () {
                            $('#dialogNextOrderToBulkDictate').html(resNextOrderBulk.responseText);
                            checkIfAllChecked();
                        });
                    } else {
                        alert("Error: " + data.Message);
                    }
                });
            } else {
                const resReq = setReportAsSkippedInBulkSession(Model.PartialReport_UID, 2).done(function (e) {
                    if (resReq.responseJSON.AllOk) {
                        const resNextOrderBulk = getNextOrderToBulkValidate(null).done(function () {
                            $('#dialogNextOrderToBulkValidate').html(resNextOrderBulk.responseText);
                            checkIfAllChecked();
                        });
                    } else {
                        alert("Error: " + data.Message);
                    }
                });
            }
        });
    });

    if (!Model.Validated && !Model.ReadOnly && !Model.Screening) {
        var activeTabID = $('div#tabs li.ui-state-active').attr('id');

        if (activeTabID && activeTabID == "openPreviewTab") {
            var reportContent = (tinymce.activeEditor.getContent().replace(/\r?\n/g, '<br />').replace(/"/g, "'"));
            setTimeout(function () {
                SetActiveReportsIFrame('previewTab', Model.OrderID, htmlEncode(reportContent), Model.PartialReport_UID, true);
            }, 10);

        }

        $('li#openPreviewTab').on('click', function (e) {
            var reportContent = (tinymce.activeEditor.getContent().replace(/\r?\n/g, '<br />').replace(/"/g, "'"));
            setTimeout(function () {
                SetActiveReportsIFrame('previewTab', Model.OrderID, htmlEncode(reportContent), Model.PartialReport_UID, true);
            }, 10);
        });
    }
    else
    {
        if ((Model.Validated || Model.ReadOnly) && !Model.Screening)
        {
            $('#loading').hide();
            setTimeout(function () {
                SetActiveReportsIFrame('previewTab', Model.OrderID, htmlEncode(Model.ReportContent), Model.PartialReport_UID, true);
            }, 10);
        }
    }

    var updateProceduresToCorrection = false;

    function setOrderAsDoneInBulkSessionReq(type) {
        var req = $.ajax({
            type: 'POST',
            url: '/legacy/Session/SetOrderAsDoneInBulkSession',
            dataType: 'json',
            data: {
                Order_UID: Model.OrderID,
                Report_UID: Model.PartialReport_UID,
                Type: type
            }
        });

        return req;
    };

    function ValidateOrSaveAndCloseFunctionality(validated, close, supervisor_uid, transcription, preliminary, triggerExportFormats, reviewer_uid) {
        triggerExportFormats = triggerExportFormats || false;

        var deletedSpeechDocument = false;
        if ($('#editableContent').length > 0) {
            var val = $('#editableContent').val();
            if (val == "true") {
                deletedSpeechDocument = true;
            }
        }

        var ratings = '';
        $('div.rating').each(function (i, y) {
            var orderProcID;
            var ratingValue;
            $(this).find('input').each(function (i, y) {
                if (!orderProcID)
                    orderProcID = $(y).attr('name').replace('proc', '').replace('rating', '');
                if ($(y).is(':checked')) {
                    ratingValue = $(y).val();
                }

            });
            ratings += orderProcID + '_' + ratingValue + '|';
        });

        $('#btnValidateAndCloseFile').attr('disabled', true);
        $('#btnSaveAndCloseFile').attr('disabled', true);
        $.ajax({
            type: 'POST',
            url: '/legacy/Locks/CheckLockFileBeforeSaving',
            data: { LockType: LockType.Report, RecordID: $('span#lockableRecordID').text() },
            async: false,
            dataType: 'json',
            success:
                function (data) {
                    if (data.Done) {
                        if (!screening) {
                            let reportContent = $('textarea#ReportContent').attr('value');
                            reportContent = reportContent?.replace(/<div>(.*?)<\/div>/gm, "$1<br>"); // TinyMCE handles <div>'s with a newline, but this doesn't happen everywhere (for example when rendering a report). So replacing those div's with <br> tags to fix this.
                            let remark = $('textarea#Remark').val();
                            let orderID = Model.OrderID;

                            var orderDocumentsInformation = [];
                            $('.scannedOrderHolder').each(function (index, element) {
                                var orderID = $(element).find('.scannedOrderID').val();
                                var rotated = $(element).find('.scannedOrderRotated').val();
                                var degrees = $(element).find('.scannedOrderDegrees').val();

                                var subDocument = {
                                    Rotated: rotated,
                                    Degrees: degrees
                                };

                                if (!orderDocumentsInformation[index]) {
                                    orderDocumentsInformation[index] = {
                                        ID: orderID,
                                        SubDocuments: []
                                    };
                                }

                                orderDocumentsInformation[index].SubDocuments.push(subDocument);
                            });

                            $.ajax({
                                type: "POST",
                                url: '/legacy/Reports/MakeOrUpdatePartialCombinationReport',
                                async: false,
                                data: {
                                    Order_UID: orderID,
                                    Report_UID: viewbagreport_UID,
                                    ForOrder_Procedure_UIDs: forOrder_ProcedureUIDs,
                                    ReportContent: reportContent,
                                    Validated: validated,
                                    Supervisor_UID: supervisor_uid,
                                    Reviewer_UID: reviewer_uid,
                                    GUID: reportGUID,
                                    DeletedSpeechDocument: deletedSpeechDocument,
                                    RemoveOrder_Procedure_UIDs: removeOrder_ProcedureUIDs,
                                    AddOrder_Procedure_UIDs: addOrder_ProcedureUIDs,
                                    Ratings: ratings,
                                    Transcription: transcription,
                                    Preliminary: preliminary,
                                    Remark: remark,
                                    ProceduresToCorrection: updateProceduresToCorrection,
                                    TriggerAdHocExportFormats: (triggerExportFormats && preliminary),
                                    OrderDocumentsInformation: orderDocumentsInformation
                                },
                                success: function (data) {
                                    $('#btnValidateAndCloseFile').removeAttr('disabled');
                                    $('#btnSaveAndCloseFile').removeAttr('disabled');

                                    if (data.PrintFail == true) {
                                        $('#divPrintFailDialog p#printMessage').html(data.Message);
                                        $('#divPrintFailDialog').dialog('open');
                                    }
                                    if (close) {
                                        eraseCookie('addOrder_ProcedureUIDs' + viewbagUniquePrefix);
                                        eraseCookie('removeOrder_ProcedureUIDs' + viewbagUniquePrefix);

                                        ReportSharedFunctions.LaunchEmptyPacsIntegration();
                                        if (!inBulk) {
                                            closeActiveFile(true, true);
                                        }
                                        else {
                                            for (var i = 0; i < timeouts.length; i++) {
                                                clearTimeout(timeouts[i]);
                                            }
                                            //quick reset of the timer array you just cleared
                                            timeouts = [];
                                            $('#loading').show();

                                            closeActiveSpeech().done(function () {
                                                const isToDictate = dictatedBy == null || dictatedBy == '';
                                                setOrderAsDoneInBulkSessionReq(isToDictate ? 1 : 2).done(function(doneInBulk) {
                                                    if (doneInBulk.AllOk) {
                                                        if (isToDictate) {
                                                            var resNextOrderBulk = getNextOrderToBulkDictate(null).done(function () {
                                                                $('#dialogNextOrderToBulkDictate').html(resNextOrderBulk.responseText);
                                                                checkIfAllChecked();
                                                            });
                                                        } else {
                                                            var resNextOrderBulk = getNextOrderToBulkValidate(null).done(function () {
                                                                $('#dialogNextOrderToBulkValidate').html(resNextOrderBulk.responseText);
                                                                checkIfAllChecked();
                                                            });
                                                        }
                                                    }
                                                    else {
                                                        alert("Error: " + doneInBulk.Message);
                                                    }
                                                });
                                            });
                                        }
                                    }
                                }
                            });
                        }
                        else {
                            //screeningstab
                            var orderID = Model.OrderID;
                            var eachDone = false;
                            var arrLetters = [];
                            var arrPoints = [];
                            var arrCircles = [];

                            $('#screeningTab li.letter').each(function (i, y) {
                                var id = $(y).attr('id');
                                var active = $(y).hasClass('active');
                                arrLetters.push([id, active]);
                            });

                            $('#screeningTab div.mamPoint').each(function (i, y) {
                                var x = $(this).css('left');
                                var y = $(this).css('top');
                                arrPoints.push([x, y]);
                            });

                            $('#screeningTab div.mamCircle').each(function (i, y) {
                                var x = $(this).css('left');
                                var y = $(this).css('top');
                                arrCircles.push([x, y]);
                            });

                            var arrPointsRequestForm = [];
                            var arrCirclesRequestForm = [];

                            $('#requestTab div.mamPoint').each(function (i, y) {
                                var x = $(this).css('left');
                                var y = $(this).css('top');
                                arrPointsRequestForm.push([x, y]);
                            });

                            $('#requestTab div.mamCircle').each(function(i, y) {
                                var x = $(this).css('left');
                                var y = $(this).css('top');
                                arrCirclesRequestForm.push([x, y]);
                            });

                            var screeningRequestForm = {
                                Order_UID: orderID,
                                Patient_RRN: $('#screeningTab dd#patientNationalRegisterNumber').text(),
                                Idgkb: $('#requestTab #Idgkb').val(),
                                Recall: $('#requestTab #Recall').val(),
                                PatientHasInvitationWith: $('#requestTab #PatientHasInvitationWith').val(),
                                PatientHasReferralWith: $('#requestTab #PatientHasReferralWith').val(),
                                ScreeningOtherDistrict: $('#requestTab #ScreeningOtherDistrict').val(),
                                AmountImages: $('#requestTab #AmountImages').val(),
                                Imager: $('#requestTab #ImagerFirstReader').prop('checked'),
                                IdentificationLaborant: $('#requestTab #IdentificationLaborant').val(),
                                MXType: $('#requestTab #MXType').val(),
                                DateMX: $('#requestTab #DateMX').val(),
                                AccessionNumber: $('#requestTab #AccessionNumber').val(),
                                PatientIdentificationNumber: $('#requestTab #PatientIdentificationNumber').val(),
                                HealthInsuranceText: $.trim($('#requestTab #HealthInsuranceText').val()),
                                InsuranceNumber: $('#requestTab #InsuranceNumber').val(),
                                GeneralPractitionerText: $.trim($('#requestTab #GeneralPractitionerText').val()),
                                Generalpractitioner_UID: $('#requestTab #GeneralPractitionerUIDGP').val(),
                                ReferringPhysicianText: $.trim($('#requestTab #ReferringPhysicianText').val()),
                                ReferringPhysician_UID: $('#requestTab #ReferringPhysician_UID').val(),
                                PhysicianCopy1Text: $.trim($('#requestTab #PhysicianCopy1Text').val()),
                                PhysicianCopy1_UID: $('#requestTab #PhysicianCopy1_UID').val(),
                                PhysicianCopy2Text: $.trim($('#requestTab #PhysicianCopy2Text').val()),
                                PhysicianCopy2_UID: $('#requestTab #PhysicianCopy2_UID').val(),
                                MXSentWith: $('#requestTab #MXSentWith').prop('checked'),
                                MXSentWithDate: $('#requestTab #MXSentWithDate').val(),
                                MXSentWithIsScreening: $('#requestTab #MXSentWithIsScreening').val(),
                                SendResultToGeneralPractitioner: $('#requestTab #SendResultToGeneralPractitioner').prop('checked'),
                                AllowCollectMonitoringData: $('#requestTab #AllowCollectMonitoringData').prop('checked'),
                                PrivacyDate: $('#requestTab #PrivacyDate').val(),
                                PrivacyProof: $('#requestTab #PrivacyProof').prop('checked'),
                                CurrentHormonalUse: $('#requestTab #CurrentHormonalUse').val(),
                                Menopause: $('#requestTab #Menopause').val(),
                                KnowledgeOfCancerInRelative: $('#requestTab #KnowledgeOfCancerInRelative').val(),
                                Outer_Right_Armpit: $('#requestTab #Outer_Right_Armpit').prop('checked'),
                                Outer_Right_ChestCentral: $('#requestTab #Outer_Right_ChestCentral').prop('checked'),
                                Outer_Right_ChestOuterUpper: $('#requestTab #Outer_Right_ChestOuterUpper').prop('checked'),
                                Outer_Right_ChestInnerUpper: $('#requestTab #Outer_Right_ChestInnerUpper').prop('checked'),
                                Outer_Right_ChestOuterUnder: $('#requestTab #Outer_Right_ChestOuterUnder').prop('checked'),
                                Outer_Right_ChestInnerUnder: $('#requestTab #Outer_Right_ChestInnerUnder').prop('checked'),
                                Outer_Right_NippleRetraction: $('#requestTab #Outer_Right_NippleRetraction').prop('checked'),
                                Outer_Right_NippleRetractionRecent: $('#requestTab #Outer_Right_NippleRetractionRecent').prop('checked'),
                                Outer_Right_WartsOrScars: $('#requestTab #Outer_Right_WartsOrScars').prop('checked'),
                                Outer_Left_Armpit: $('#requestTab #Outer_Left_Armpit').prop('checked'),
                                Outer_Left_ChestCentral: $('#requestTab #Outer_Left_ChestCentral').prop('checked'),
                                Outer_Left_ChestOuterUpper: $('#requestTab #Outer_Left_ChestOuterUpper').prop('checked'),
                                Outer_Left_ChestInnerUpper: $('#requestTab #Outer_Left_ChestInnerUpper').prop('checked'),
                                Outer_Left_ChestOuterUnder: $('#requestTab #Outer_Left_ChestOuterUnder').prop('checked'),
                                Outer_Left_ChestInnerUnder: $('#requestTab #Outer_Left_ChestInnerUnder').prop('checked'),
                                Outer_Left_NippleRetraction: $('#requestTab #Outer_Left_NippleRetraction').prop('checked'),
                                Outer_Left_NippleRetractionRecent: $('#requestTab #Outer_Left_NippleRetractionRecent').prop('checked'),
                                Outer_Left_WartsOrScars: $('#requestTab #Outer_Left_WartsOrScars').prop('checked'),
                                Remarks: $('#requestTab #Remarks').val(),
                                ArrPointsRequestForm: JSON.stringify(arrPointsRequestForm),
                                ArrCirclesRequestForm: JSON.stringify(arrCirclesRequestForm)
                            };

                            $.ajax({
                                type: "POST",
                                traditional: true,
                                url: '/legacy/Reports/MakeOrUpdatePartialCombinationScreeningReport',
                                async: false,
                                data: {
                                    Order_UID: orderID,
                                    Report_UID: viewbagreport_UID,
                                    ForOrder_Procedure_UIDs: forOrder_ProcedureUIDs,
                                    ArrLetters: JSON.stringify(arrLetters),
                                    PatientNationalRegisterNumber: $('#screeningTab dd#patientNationalRegisterNumber').text(),
                                    PatientName: $('#screeningTab dd#patientName').text(),
                                    PatientDOB: $('#screeningTab dd#patientDOB').text(),
                                    PatientAddress: $('#screeningTab dd#patientAddress').text(),
                                    PatientRequestingPhysician: $('#screeningTab dd#patientRequestingPhysician').text(),
                                    Reader: $('#screeningTab #reader').val(),
                                    UserName: $('#screeningTab #UserName').text(),
                                    LaborantID: $('#screeningTab #beeldvormerLaborantID').val(),
                                    NumberImages: $('#screeningTab #numberImages').val(),
                                    LastMXToCompare: $('#screeningTab input#MXcompYes').prop('checked'),
                                    LastMXDate: $('#screeningTab input#dateLastMX').val(),
                                    LastMXCompared: $('#screeningTab input#compYes').prop('checked'),
                                    LastMXInjury: $('#screeningTab input[name=injury][checked=checked]').val(),
                                    LastMXDigital: $('#screeningTab input#MXCompareTypeDIGI').prop('checked'),
                                    Imager: $('#screeningTab #beeldvormerLaborant').prop('checked'),
                                    Priority: $('#screeningTab #prioritair').prop('checked'),
                                    PriorityReason: $('#screeningTab #prioritairReason').val(),
                                    ImprovementNotPossibleReason: $('#screeningTab #improvementNotPossible').val(),
                                    Remarks: $('#screeningTab #comments').val(),
                                    ME: $('#screeningTab #identificatieME').val(),
                                    ArrPoints: JSON.stringify(arrPoints),
                                    ArrCircles: JSON.stringify(arrCircles),
                                    Validated: validated,
                                    Template_Screening_UID: Model.ScreeningTemplate_UID,
                                    Supervisor_UID: supervisor_uid,
                                    RemoveOrder_Procedure_UIDs: removeOrder_ProcedureUIDs,
                                    AddOrder_Procedure_UIDs: addOrder_ProcedureUIDs,
                                    Radiologist_UID: $('#screeningTab #screeningRadiologist_UID').val(),
                                    Technician_UID: $('#screeningTab #screeningTechnician_UID').val(),
                                    RequestFormInformation_Data: JSON.stringify(screeningRequestForm)
                                },
                                success: function (data) {
                                    if (data.PrintFail == true) {
                                        $('#divPrintFailDialog p#printMessage').html(data.Message);
                                        $('#divPrintFailDialog').dialog('open');
                                    }
                                    if (close) {
                                        eraseCookie('addOrder_ProcedureUIDs' + viewbagUniquePrefix);
                                        eraseCookie('removeOrder_ProcedureUIDs' + viewbagUniquePrefix);

                                        ReportSharedFunctions.LaunchEmptyPacsIntegration();
                                        if (!inBulk) {
                                            closeActiveFile(true, true);
                                        }
                                        else {
                                            for (var i = 0; i < timeouts.length; i++) {
                                                clearTimeout(timeouts[i]);
                                            }
                                            //quick reset of the timer array you just cleared
                                            timeouts = [];
                                            $('#loading').show();
                                            closeActiveSpeech().done(function () {
                                                var isToDictate = dictatedBy == null || dictatedBy == '';
                                                $.ajax({
                                                    type: 'POST',
                                                    url: '/legacy/Session/SetOrderAsDoneInBulkSession',
                                                    dataType: 'json',
                                                    async: false,
                                                    data: {
                                                        Order_UID: Model.OrderID,
                                                        Report_UID: Model.PartialReport_UID,
                                                        Type: isToDictate ? 1 : 2
                                                    },
                                                    success: function (data2) {
                                                        if (data2.AllOk) {
                                                            if (isToDictate) {
                                                                var resNextOrderBulk = getNextOrderToBulkDictate(null).done(function () {
                                                                    $('#dialogNextOrderToBulkDictate').html(resNextOrderBulk.responseText);
                                                                    checkIfAllChecked();
                                                                });
                                                            } else {
                                                                var resNextOrderBulk = getNextOrderToBulkValidate(null).done(function () {
                                                                    $('#dialogNextOrderToBulkValidate').html(resNextOrderBulk.responseText);
                                                                    checkIfAllChecked();
                                                                });
                                                            }
                                                        }
                                                        else {
                                                            alert("Error: " + data2.Message);
                                                        }
                                                    }
                                                });
                                            });
                                        }
                                    }
                                }
                            });
                        }
                    }
                    else if (!data.Done) {
                        $('#btnValidateAndCloseFile').removeAttr('disabled');
                        $('#btnSaveAndCloseFile').removeAttr('disabled');

                        $('#divNotLockedDialog').dialog('open');
                    }
                }
        });
    };

    // Needed to call ValidateOrCloseAndSave from _ReportDialogs JS context
    window.GlobalValidateOrSaveAndClose = (validated, close, transcription, preliminary, triggerExportFormats, reviewerID) => {
        toValidate = validated;
        toClose = close;
        toTranscription = transcription;
        toPreliminary = preliminary;
        toTriggerExportFormats = triggerExportFormats;

        ValidateOrSaveAndClose(toValidate, toClose, null, toTranscription, toPreliminary, toTriggerExportFormats, reviewerID);
    };

    function ValidateOrSaveAndClose(validated, close, supervisor_uid, transcription, preliminary, triggerExportFormats, reviewer_uid) {
        triggerExportFormats = triggerExportFormats || false;

        if (CheckReportDictatedForChecks(Model.OrderID))
        {
            ValidateOrSaveAndCloseFunctionality(validated, close, supervisor_uid, transcription, preliminary, triggerExportFormats, reviewer_uid);
        }
        else
        {
            gValidated = validated;
            gTranscription = transcription;
            gPreliminary = preliminary;
            gTriggerExportFormats = triggerExportFormats;
            gClose = close;
            gSupervisor_uid = supervisor_uid;
            gReviewer_uid = reviewer_uid;
            $('#divPopupConfirmationChecksRemaining').dialog('open');
        }
    };



    if (!Model.ConfirmedInvoice) {
        GetToVerifyNomenclatures(0, 0, 0, true);
    }



    function UpdateOrderNomenclatures(ok) {
        var remarks = $('#confirmationRemarksText').val();

        var procs = [];
        $('tr.nomenGroup').each(function (i, obj) {
            var toRep = $(obj).find('input[name=EditableProcedure]').val();
            var toRepProc = $(obj).find('input[name=ProcedureID]').val();
            procs.push([toRep, toRepProc]);
        });

        var confirmInvoice = $('#ConfirmInvoiceOnConfirmation').prop('checked');
        var adjustInvoice = $('#AdjustInvoiceOnConfirmNomenclatures').prop('checked');

        $.ajax({
            type: 'POST',
            async: false,
            url: '/legacy/Reports/UpdateOrderAfterConfirmation',
            data: {
                Order_UID: Model.OrderID,
                Remarks: remarks,
                Ok: ok,
                ProcedureReplacements: JSON.stringify(procs),
                ConfirmInvoice: confirmInvoice,
                AdjustInvoice: adjustInvoice
            },
            dataType: 'json',
            success:
                function (data) {
                    if (data.AllOk) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
        });
    }

    function SaveAfterConfirmation(ok) {
        var validate = $('input#validatePopup').val();

        if (!ok) {
            updateProceduresToCorrection = true;
        }

        if (UpdateOrderNomenclatures(ok) && (validate == 1 || validate == 2 || validate == 3 || validate == 4)) {
        }
        else {
            $('#verifyNomenclatures').hide();
            $('#divPopupConfirmation' + viewbagUniquePrefix).dialog('close');
        }

        //Validate and close
        if (validate == 1) {
            if (isAssistentRadiologist) {
                ShowPopupChooseSupervisor(true, true, false, false);
            }
            else {
                if (userRadiologistId != 0 && Model.SupervisorId != null && userRadiologistId !== Model.SupervisorId) {
                    ShowPopupSetCurrentRadiologistAsSupervisor(true, true, false, false)
                }
                else {
                    ValidateOrSaveAndClose(true, true, null, false, false, Model.OrderProcedures[0].Reviewer_UID);
                }
            }
        }
        //Don't validate close
        else if (validate == 2) {
            if (isAssistentRadiologist) {
                ShowPopupChooseSupervisor(false, true, false, false);
            }
            else {
                ValidateOrSaveAndClose(false, true, null, false, false, Model.OrderProcedures[0].Reviewer_UID);
            }
        }
        else if (validate == 3) {
            //transcription
            if (isAssistentRadiologist) {
                ShowPopupChooseSupervisor(false, true, true, false);
            }
            else {
                ValidateOrSaveAndClose(false, true, null, true, false, Model.OrderProcedures[0].Reviewer_UID);
            }
        }
        else if (validate == 4) {
            //preliminary
            if (isAssistentRadiologist) {
                ShowPopupChooseSupervisor(false, true, false, true);
            }
            else {
                ValidateOrSaveAndClose(false, true, null, false, true, Model.OrderProcedures[0].Reviewer_UID);
            }
        }
    }

    $('button#btnNOKPopupConfirmation' + viewbagUniquePrefix).on('click', function (e) {
        SaveAfterConfirmation(false);
    });

    $('button#btnOKPopupConfirmation' + viewbagUniquePrefix).on('click', function (e) {
        SaveAfterConfirmation(true);
    });

    function showConfirmationPopup(validate) {
        $('#divPopupConfirmation' + viewbagUniquePrefix).find('input#validatePopup').val(validate);
        if (validate == 1) {
            $('#divPopupConfirmation' + viewbagUniquePrefix).dialog('option', 'title', $("<div/>").html(window.Resources.VerifyNomenclatures + ' - '  + window.Resources.ValidateAndClose).text());
        }
        else if (validate == 2) {
            $('#divPopupConfirmation' + viewbagUniquePrefix).dialog('option', 'title', $("<div/>").html(window.Resources.VerifyNomenclatures + ' - ' + window.Resources.SaveAndClose).text());
        }
        else if (validate == 3) {
            $('#divPopupConfirmation' + viewbagUniquePrefix).dialog('option', 'title', $("<div/>").html(window.Resources.VerifyNomenclatures + ' - ' + window.Resources.Transcription).text());
        }
        else if (validate == 4) {
            $('#divPopupConfirmation' + viewbagUniquePrefix).dialog('option', 'title', $("<div/>").html(window.Resources.VerifyNomenclatures + ' - ' + window.Resources.Preliminary).text());
        }
        else {
            $('#divPopupConfirmation' + viewbagUniquePrefix).dialog('option', 'title', $("<div/>").html(window.Resources.VerifyNomenclatures).text());
        }

        $('#divPopupConfirmation' + viewbagUniquePrefix).dialog('open');
    }

    function CheckReportContentBeforeSaving(dontCheckEmpty, action) {
        if (!showEmptyReportConfirmation || dontCheckEmpty)
        {
            return true;
        }
        else {
            if (!screening) {
                let reportContent = $('textarea#ReportContent').attr('value') ? $('textarea#ReportContent').attr('value') : '';
                reportContent = reportContent?.replace(/<div>(.*?)<\/div>/gm, "$1<br>");
                reportContent = reportContent.replace(/\r?\n/g, '<br>');
                reportContent = reportContent.replace(/<br>/gi, '');
                reportContent = reportContent.replace(/<br \/>/gi, '');
                reportContent = reportContent.replace(/<br\/>/gi, '');
                reportContent = reportContent.replace(/&nbsp;/gi, '');
                reportContent = $.trim(reportContent);
                if (!reportContent) {
                    if (action == 1) {
                        $("#toConfirmActionText").text(htmlDecode(window.Resources.toSave));
                        $("#toConfirmAction").val(1);
                    } else if (action == 2) {
                        $("#toConfirmActionText").text(htmlDecode(window.Resources.toValidate));
                        $("#toConfirmAction").val(2);
                    } else if (action == 3) {
                        $("#toConfirmActionText").text(htmlDecode(window.Resources.Transcription));
                        $("#toConfirmAction").val(3);
                    } else if (action == 4) {
                        $("#toConfirmActionText").text(htmlDecode(window.Resources.Preliminary));
                        $("#toConfirmAction").val(4);
                    }
                    $("#divPopupConfirmationEmpty").dialog("open");
                    return false;
                }
                return true;
            }
            else {
                return true;
            }
        }
    };

    $('#btnConfirmEmptyOk').on('click', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();

        $('#divPopupConfirmationEmpty').dialog('close');

        var action = $('#toConfirmAction').val();
        if (action == 1) {
            $('#btnSaveAndCloseFile').trigger('click', [false, true]);
        }
        else if (action == 2) {
            $('#btnValidateAndCloseFile').trigger('click', [false, true]);
        }
        else if (action == 3) {
            $('#btnSendToTranscription').trigger('click', [false, true]);
        }
        else if (action == 4) {
            if (gTriggerExportFormats) {
                $('#btnSendToPreliminaryAndTriggerExportFormats').trigger('click', [false, true]);
            } else {
                $('#btnSendToPreliminary').trigger('click', [false, true]);
            }
        }

        $('#divPopupConfirmationEmpty').dialog('close');
    });

    $('#showAllImages').on('click', function(e){
        const numbers = Model.ProceduresInOrderReport.InReport.map(orderProcedure => orderProcedure.OrderHasProcedure_UID);
        ReportSharedFunctions.LaunchPacsIntegrationFor(numbers, multiple);
    })

    var inputDateRegex = /^([0-2][0-9]|3[0-1])[\/](0[1-9]|1[0-2])[\/]([12][90][0-9][0-9])$/;

    function ValidateScreeningInputFields(e) {
        //CHECK VALIDATED INPUT FIELDS
        var generalOK = true;
        var leftOK = true;
        var rightOK = true;
        var rightmessage = '';
        var leftmessage = '';
        var generalmessage = '';
        var LeftLocalisations = false;
        var RightLocalisations = false;

        //GET ARRPOINTS AND ARRCIRCLES
        var arrPoints = [];
        var arrCircles = [];

        $('#screeningTab div.mamPoint').each(function (i, y) {
            var x = $(this).css('left');
            var y = $(this).css('top');
            arrPoints.push([x, y]);
        });

        $('#screeningTab div.mamCircle').each(function (i, y) {
            var x = $(this).css('left');
            var y = $(this).css('top');
            arrCircles.push([x, y]);
        });

        $.ajax({
            type: "POST",
            traditional: true,
            url: '/legacy/Reports/GetLeftRightPointsAndCircles',
            async: false,
            data: {
                ArrPoints: JSON.stringify(arrPoints),
                ArrCircles: JSON.stringify(arrCircles)

            },
            success: function (data) {
                if(data.AllOk)
                {
                    LeftLocalisations = data.Left;
                    RightLocalisations = data.Right;
                }
            },
            error: function(request, textStatus, errorThrown) {
                alert("request: " + request.responseText + "; Status: " + textStatus + "; Error: " + errorThrown);
            }
        });

        //RRN HAS TO BE KNOWN FOR PATIENT
        if($('#patientNationalRegisterNumber').text() == "{patientNationalRegisterNumber}" || $.trim($('#patientNationalRegisterNumber').text()) == "")
        {
            generalOK = false;
            generalmessage += "<p>Rijksregisternummer van de patiënt dient gekend te zijn. Update de patiënt.</p>";
        }

        //REGEXKES
        if ($('#MXcompYes').prop('checked')) {
            var lastMX = $('#dateLastMX').val();
            if ($.trim(lastMX) == "" || !inputDateRegex.test(lastMX)) {
                generalOK = false;
                $('div#dateLastMXDiv span.required').show();
                generalmessage += "<p>Datum vergeleken MX heeft niet het correcte formaat (dd/MM/yyyy)</p>";
            }
            else
            {
                if(new Date(lastMX.split("/")[2],parseInt(lastMX.split("/")[1])-1,lastMX.split("/")[0]) >= Date.now())
                {
                    generalOK = false;
                    $('div#dateLastMXDiv span.required').show();
                    generalmessage += "<p>Datum vergeleken MX dient in het verleden te liggen.</p>";
                }
                if(new Date(lastMX.split("/")[2],parseInt(lastMX.split("/")[1])-1,lastMX.split("/")[0]) >= new Date(Model.OrderDateOfImplementation.substr(6,4),parseInt(Model.OrderDateOfImplementation.substr(3,2))-1,Model.OrderDateOfImplementation.substr(0,2)))
                {
                    generalOK = false;
                    $('div#dateLastMXDiv span.required').show();
                    generalmessage += "<p>Datum vergeleken MX dient kleiner te zijn dan MX datum.</p>";
                }
            }
        }

        //AANTAL HAS TO BE > 0
        var aantalBeelden = $('#numberImages').val();
        if(aantalBeelden <= 0)
        {
            generalOK = false;
            $('div#numberImagesDiv span.required').show();
            generalmessage += "<p>Aantal beelden dient groter te zijn dan 0</p>";
        }

        //READER HAS TO HAVE LENGTH 8
        if($('#reader').val().length != 8)
        {
            generalOK = false;
            $('div#readerDiv span.required').show();
            generalmessage += "<p>Lezer dient 8 getallen lang te zijn</p>";
        }

        //ME HAS TO BE NUMERIC
        if(!$.isNumeric($('#identificatieME').val()))
        {
            generalOK = false;
            $('div#MEDiv span.required').show();
            generalmessage += "<p>ME dient numeriek te zijn</p>";
        }

        //WHEN TECHNICAL QUALITY IS NOT GOOD BUT NOT POSSIBLE TO DO BETTER, A REASON HAS TO BE GIVEN
        if($('#032R').hasClass('active') && $.trim($('#improvementNotPossible').val()) == "")
        {
            rightOK = false;
            rightmessage += "<p>Gelieve een reden op te geven waarom de technische kwaliteit niet beter kan.</p>";
        }
        if($('#032L').hasClass('active') && $.trim($('#improvementNotPossible').val()) == "")
        {
            leftOK = false;
            leftmessage += "<p>Gelieve een reden op te geven waarom de technische kwaliteit niet beter kan.</p>";
        }

        //WHEN PRIORITY CHECKBOX IS CHECKED, A REASON HAS TO BE GIVEN
        if($('#prioritair').prop('checked') && $('#prioritairReason').val().trim().length === 0)
        {
            generalOK = false;
            $('div#priorityDiv span.required').show();
            generalmessage += "<p>Gelieve een reden op te geven voor prioritair behandelen</p>";
        }

        //WHEN A PRIORITY REASON IS GIVEN AND THE CHECKBOX IS NOT CHECKED
        if(!$('#prioritair').prop('checked') && $.trim($('#prioritairReason').val()).length != 0)
        {
            generalOK = false;
            $('div#priorityDiv span.required').show();
            generalmessage += "<p>Er werd een reden opgegeven voor prioritair behandelen, maar de checkbox is niet actief.</p>";
        }

        //IF CALCIFICATIONS ARE SUSPICIOUS, AT LEAST ONE LOCALISATION HAS TO BE GIVEN
        if($('#035R').hasClass('active') && ($('#011R').hasClass('active') || $('#002R').hasClass('active')))
        {
            if(!RightLocalisations)
            {
                rightOK = false;
                rightmessage += "<p>Gelieve minstens 1 localisatie aan te duiden.</p>";
            }
        }
        if(($('#035L').hasClass('active') && ($('#011L').hasClass('active')) ||$('#002L').hasClass('active')))
        {
            if(!LeftLocalisations)
            {
                leftOK = false;
                leftmessage += "<p>Gelieve minstens 1 localisatie aan te duiden.</p>";
            }
        }


        //LOCALISATIONS NOT ALLOWED WHEN NOT SUSPICIOUS
        if($('#010R').hasClass('active') && $('#001R').hasClass('active'))
        {
            if(RightLocalisations)
            {
                rightOK = false;
                rightmessage += "<p>Er mogen geen localisaties opgegeven worden indien geen verdachte afwijkingen of calcificaties</p>";
            }
        }
        if($('#010L').hasClass('active') && $('#001L').hasClass('active'))
        {
            if(LeftLocalisations)
            {
                leftOK = false;
                leftmessage += "<p>Er mogen geen localisaties opgegeven worden indien geen verdachte afwijkingen of calcificaties</p>";
            }
        }

        //WHEN CONCLUSION IS "VERDERE OPPUNTSTELLING" THEN "TE WEERHOUDEN OMWILLE VAN" AND/OR "VERDACHT" HAS TO BE FILLED OUT AND THE "GEVOLG" HAS TO BE "VERDER ONDERZOEK"
        if($('#035R').hasClass('active'))
        {
            if((!$('#002R').hasClass('active') && !$('#011R').hasClass('active')) || !$('#039R').hasClass('active'))
            {
                rightOK = false;
                rightmessage += "<p>Indien conclusie 'Verdere oppuntstelling' is, dan moet 'te weerhouden omwille van' en/of 'verdacht' ingevuld zijn en dient het gevolg 'verder onderzoek' te zijn.</p>";
            }

        }
        if($('#035L').hasClass('active'))
        {
            if((!$('#002L').hasClass('active') && !$('#011L').hasClass('active')) || !$('#039L').hasClass('active'))
            {
                leftOK = false;
                leftmessage += "<p>Indien conclusie 'Verdere oppuntstelling' is, dan moet 'te weerhouden omwille van' en/of 'verdacht' ingevuld zijn en dient het gevolg 'verder onderzoek' te zijn.</p>";
            }
        }


        //IF CONCLUSION IS NOT "VERDERE OPPUNTSTELLING", "Te weerhouden omwille van" AND/OR "VERDACHT" ARE NOT ALLOWED TO BE FILLED OUT
        if(!$('#035R').hasClass('active'))
        {
            if(!$('#035R').hasClass('active') && ($('#002R').hasClass('active') || $('#011R').hasClass('active')))
            {
                rightOK = false;
                rightmessage += "<p>Indien conclusie verschillend is van 'Verdere oppuntstelling', dan is het niet toegestaan 'verdacht' of 'te weerhouden omwille van' in te vullen.</p>";
            }
        }
        if(!$('#035L').hasClass('active'))
        {
            if(!$('#035L').hasClass('active') && ($('#002L').hasClass('active') || $('#011L').hasClass('active')))
            {
                leftOK = false;
                leftmessage += "<p>Indien conclusie verschillend is van 'Verdere oppuntstelling', dan is het niet toegestaan 'verdacht' of 'te weerhouden omwille van' in te vullen.</p>";
            }
        }

        //IF LABORANT IS CHECKED, AN ID HAS TO BE GIVEN FOR THE LABORANT
        if($('#beeldvormerLaborant').is(':checked') && $.trim($('#beeldvormerLaborantID').val()) == "")
        {
            generalOK = false;
            $('div#laborantDiv span.required').show();
            generalmessage += "<p>Gelieve een laborant ID op te geven.</p>";
        }

        //IF TECHNICAL REASON IS "NIET GOED MAAR KAN NIET BETER" THEN CONCLUSION CAN NOT BE RECALL
        if($('#032R').hasClass('active') && $('#036R').hasClass('active'))
        {
            rightOK = false;
            rightmessage += "<p>Als 'niet goed maar kan niet beter', dan moet conclusie 'geen afwijking', 'goedaardige afwijking' of 'verdere oppuntstelling' zijn.</p>";
        }
        if($('#032L').hasClass('active') && $('#036L').hasClass('active'))
        {
            leftOK = false;
            leftmessage += "<p>Als 'niet goed maar kan niet beter', dan moet conclusie 'geen afwijking', 'goedaardige afwijking' of 'verdere oppuntstelling' zijn.</p>";
        }

        //CHECK IF ANY AFWIJKING HAS BEEN SELECTED, WHEN CONCLUSION IS NOT RECALL OR MASTECTOMY
        if(!$('#036R').hasClass('active') && !$('#037R').hasClass('active'))
        {
            if(!$('#001R').hasClass('active') && !$('#002R').hasClass('active') && !$('#003R').hasClass('active') && !$('#004R').hasClass('active') && !$('#005R').hasClass('active') && !$('#006R').hasClass('active') && !$('#007R').hasClass('active') && !$('#008R').hasClass('active') && !$('#009R').hasClass('active'))
            {
                rightOK = false;
                rightmessage += "<p>Gelieve de sectie 'Afwijking' in te vullen.</p>";
            }
        }
        if(!$('#036L').hasClass('active') && !$('#037L').hasClass('active'))
        {
            if(!$('#001L').hasClass('active') && !$('#002L').hasClass('active') && !$('#003L').hasClass('active') && !$('#004L').hasClass('active') && !$('#005L').hasClass('active') && !$('#006L').hasClass('active') && !$('#007L').hasClass('active') && !$('#008L').hasClass('active') && !$('#009L').hasClass('active'))
            {
                leftOK = false;
                leftmessage += "<p>Gelieve de sectie 'Afwijking' in te vullen.</p>";
            }
        }

        //CHECK IF ANY CALCIFICATION HAS BEEN SELECTED, WHEN CONCLUSION IS NOT RECALL OR MASTECTOMY
        if(!$('#036R').hasClass('active') && !$('#037R').hasClass('active'))
        {
            if(!$('#010R').hasClass('active') && !$('#011R').hasClass('active'))
            {
                rightOK = false;
                rightmessage += "<p>Gelieve de sectie 'Calcificaties' in te vullen.</p>";
            }
        }
        if(!$('#036L').hasClass('active') && !$('#037L').hasClass('active'))
        {
            if(!$('#010L').hasClass('active') && !$('#011L').hasClass('active'))
            {
                leftOK = false;
                leftmessage += "<p>Gelieve de sectie 'Calcificaties' in te vullen.</p>";
            }
        }

        //CHECK IF ANY SAMENSTELLING BORSTWEEFSEL HAS BEEN SELECTED, WHEN CONCLUSION IS NOT RECALL OR MASTECTOMY
        if(!$('#036R').hasClass('active') && !$('#037R').hasClass('active'))
        {
            if(!$('#012R').hasClass('active') && !$('#013R').hasClass('active') && !$('#014R').hasClass('active') && !$('#015R').hasClass('active'))
            {
                rightOK = false;
                rightmessage += "<p>Gelieve de sectie 'Samenstelling Borstweefsel' in te vullen.</p>";
            }
        }
        if(!$('#036L').hasClass('active') && !$('#037L').hasClass('active'))
        {
            if(!$('#012L').hasClass('active') && !$('#013L').hasClass('active') && !$('#014L').hasClass('active') && !$('#015L').hasClass('active'))
            {
                leftOK = false;
                leftmessage += "<p>Gelieve de sectie 'Samenstelling Borstweefsel' in te vullen.</p>";
            }
        }

        //CHECK IF ANY SAMENSTELLING BORSTWEEFSEL HAS BEEN SELECTED, WHEN CONCLUSION IS NOT MASTECTOMY
        if(!$('#037R').hasClass('active'))
        {
            if(!$('#016R').hasClass('active') && !$('#017R').hasClass('active') && !$('#018R').hasClass('active') && !$('#019R').hasClass('active') && !$('#020R').hasClass('active') && !$('#021R').hasClass('active') && !$('#022R').hasClass('active') && !$('#023R').hasClass('active') && !$('#024R').hasClass('active') && !$('#025R').hasClass('active') && !$('#026R').hasClass('active') && !$('#027R').hasClass('active') && !$('#028R').hasClass('active') && !$('#029R').hasClass('active') && !$('#030R').hasClass('active') && !$('#031R').hasClass('active') && !$('#032R').hasClass('active'))
            {
                rightOK = false;
                rightmessage += "<p>Gelieve de sectie 'Technische Kwaliteit' in te vullen.</p>";
            }
        }
        if(!$('#037L').hasClass('active'))
        {
            if(!$('#016L').hasClass('active') && !$('#017L').hasClass('active') && !$('#018L').hasClass('active') && !$('#019L').hasClass('active') && !$('#020L').hasClass('active') && !$('#021L').hasClass('active') && !$('#022L').hasClass('active') && !$('#023L').hasClass('active') && !$('#024L').hasClass('active') && !$('#025L').hasClass('active') && !$('#026L').hasClass('active') && !$('#027L').hasClass('active') && !$('#028L').hasClass('active') && !$('#029L').hasClass('active') && !$('#030L').hasClass('active') && !$('#031L').hasClass('active') && !$('#032L').hasClass('active'))
            {
                leftOK = false;
                leftmessage += "<p>Gelieve de sectie 'Technische Kwaliteit' in te vullen.</p>";
            }
        }

        //CHECK IF ANY CONCLUSION HAS BEEN SELECTED
        if(!$('#033R').hasClass('active') && !$('#034R').hasClass('active') && !$('#035R').hasClass('active') && !$('#036R').hasClass('active') && !$('#037R').hasClass('active'))
        {
            rightOK = false;
            rightmessage += "<p>Gelieve de sectie 'Conclusie' in te vullen.</p>";
        }
        if(!$('#033L').hasClass('active') && !$('#034L').hasClass('active') && !$('#035L').hasClass('active') && !$('#036L').hasClass('active') && !$('#037L').hasClass('active'))
        {
            leftOK = false;
            leftmessage += "<p>Gelieve de sectie 'Conclusie' in te vullen.</p>";
        }

        //CHECK IF ANY GEVOLG HAS BEEN SELECTED, WHEN CONCLUSION IS NOT RECALL OR MASTECTOMY
        if(!$('#036R').hasClass('active') && !$('#037R').hasClass('active'))
        {
            if(!$('#038R').hasClass('active') && !$('#039R').hasClass('active') && !$('#040R').hasClass('active') && !$('#041R').hasClass('active') && !$('#042R').hasClass('active') && !$('#043R').hasClass('active'))
            {
                rightOK = false;
                rightmessage += "<p>Gelieve de sectie 'Gevolg' in te vullen.</p>";
            }
        }
        if(!$('#036L').hasClass('active') && !$('#037L').hasClass('active'))
        {
            if(!$('#038L').hasClass('active') && !$('#039L').hasClass('active') && !$('#040L').hasClass('active') && !$('#041L').hasClass('active') && !$('#042L').hasClass('active') && !$('#043L').hasClass('active'))
            {
                leftOK = false;
                leftmessage += "<p>Gelieve de sectie 'Gevolg' in te vullen.</p>";
            }
        }

        //IF 'TE WEERHOUDEN OMWILLE VAN' THEN SOLITAIR OR MEERDERE HAS TO BE SELECTED
        if($('#002R').hasClass('active') && (!$('#008R').hasClass('active') && !$('#009R').hasClass('active')))
        {
            rightOK = false;
            rightmessage += "<p>Indien 'te weerhouden omwille van' is ingevuld, dient 'solitair' of 'meerdere' geselecteerd te worden.</p>";
        }
        if($('#002L').hasClass('active') && (!$('#008L').hasClass('active') && !$('#009L').hasClass('active')))
        {
            leftOK = false;
            leftmessage += "<p>Indien 'te weerhouden omwille van' is ingevuld, dient 'solitair' of 'meerdere' geselecteerd te worden.</p>";
        }

        //IF 'TE WEERHOUDEN OMWILLE VAN' THEN UNDERLYING REASON HAS TO BE SELECTED
        if($('#002R').hasClass('active') && (!$('#003R').hasClass('active') && !$('#004R').hasClass('active') && !$('#005R').hasClass('active') && !$('#006R').hasClass('active') && !$('#007R').hasClass('active')))
        {
            rightOK = false;
            rightmessage += "<p>Indien 'te weerhouden omwille van' is ingevuld, dient een onderliggende reden geselecteerd te worden.</p>";
        }
        if($('#002L').hasClass('active') && (!$('#003L').hasClass('active') && !$('#004L').hasClass('active') && !$('#005L').hasClass('active') && !$('#006L').hasClass('active') && !$('#007L').hasClass('active')))
        {
            leftOK = false;
            leftmessage += "<p>Indien 'te weerhouden omwille van' is ingevuld, dient een onderliggende reden geselecteerd te worden.</p>";
        }

        //IF A REASON WHY NIET GOED MAAR KAN NIET BETER IS GIVEN, BUT THE BUTTON IS NOT ACTIVE
        if((!$('#032R').hasClass('active') && !$('#032L').hasClass('active')) && $.trim($('#improvementNotPossible').val()).length > 0)
        {
            generalOK = false;
            generalmessage += "<p>Er werd een reden opgegeven, maar 'Niet goed maar kan niet beter' is niet actief.</p>";
        }

        //TECHNICAL QUALITY NOT GOOD, BUT NO REASON SELECTED
        if($('#019R').hasClass('active') && !$('#020R').hasClass('active') && !$('#021R').hasClass('active') && !$('#022R').hasClass('active') && !$('#023R').hasClass('active'))
        {
            rightOK = false;
            rightmessage += "<p>Gelieve een reden waarom 'Niet goed technisch-fysisch' aan te duiden.</p>";
        }
        if($('#019L').hasClass('active') && !$('#020L').hasClass('active') && !$('#021L').hasClass('active') && !$('#022L').hasClass('active') && !$('#023L').hasClass('active'))
        {
            leftOK = false;
            leftmessage += "<p>Gelieve een reden waarom 'Niet goed technisch-fysisch' aan te duiden.</p>";
        }
        if($('#024R').hasClass('active') && !$('#025R').hasClass('active') && !$('#026R').hasClass('active') && !$('#027R').hasClass('active') && !$('#028R').hasClass('active') && !$('#029R').hasClass('active') && !$('#030R').hasClass('active') && !$('#031R').hasClass('active') && !$('#032R').hasClass('active'))
        {
            rightOK = false;
            rightmessage += "<p>Gelieve een reden waarom 'Niet goed positionering' aan te duiden.</p>";
        }
        if($('#024L').hasClass('active') && !$('#025L').hasClass('active') && !$('#026L').hasClass('active') && !$('#027L').hasClass('active') && !$('#028L').hasClass('active') && !$('#029L').hasClass('active') && !$('#030L').hasClass('active') && !$('#031L').hasClass('active') && !$('#032L').hasClass('active'))
        {
            leftOK = false;
            leftmessage += "<p>Gelieve een reden waarom 'Niet goed positionering' aan te duiden.</p>";
        }

        //FURTHER INVESTIGATION SELECTED, BUT NO REASON
        if($('#039R').hasClass('active') && !$('#040R').hasClass('active') && !$('#041R').hasClass('active') && !$('#042R').hasClass('active') && !$('#043R').hasClass('active'))
        {
            rightOK = false;
            rightmessage += "<p>Gelieve een reden voor 'Verder onderzoek' te selecteren.</p>";
        }
        if($('#039L').hasClass('active') && !$('#040L').hasClass('active') && !$('#041L').hasClass('active') && !$('#042L').hasClass('active') && !$('#043L').hasClass('active'))
        {
            leftOK = false;
            leftmessage += "<p>Gelieve een reden voor 'Verder onderzoek' te selecteren.</p>";
        }

        //WHEN MASTECTOMY OR RECALL, NO LOCALISATIONS CAN BE PRESENT
        if($('#036R').hasClass('active') || $('#037R').hasClass('active'))
        {
            if(RightLocalisations)
            {
                rightOK = false;
                rightmessage += "<p>Er mogen geen localisaties opgegeven worden indien technisch niet interpreteerbaar of mastectomie.</p>";
            }
        }
        if($('#036L').hasClass('active') || $('#037L').hasClass('active'))
        {
            if(LeftLocalisations)
            {
                leftOK = false;
                leftmessage += "<p>Er mogen geen localisaties opgegeven worden indien technisch niet interpreteerbaar of mastectomie.</p>";
            }
        }

        //WHEN 'VERDER ONDERZOEK' IS NOT SELECTED, BUT ONE OF THE UNDERLYING REASONS IS SELECTED
        if(!$('#039R').hasClass('active') && ($('#040R').hasClass('active') || $('#041R').hasClass('active') || $('#042R').hasClass('active') || $('#043R').hasClass('active')))
        {
            rightOK = false;
            rightmessage += "<p>Er werd een gevolg voor 'Verder onderzoek' aangeduid, hoewel 'verder onderzoek' niet geselecteerd werd.</p>";
        }
        if(!$('#039L').hasClass('active') && ($('#040L').hasClass('active') || $('#041L').hasClass('active') || $('#042L').hasClass('active') || $('#043L').hasClass('active')))
        {
            rightOK = false;
            rightmessage += "<p>Er werd een gevolg voor 'Verder onderzoek' aangeduid, hoewel 'verder onderzoek' niet geselecteerd werd.</p>";
        }


        $('span.validationAreaGeneral').html(generalmessage);
        $('span.validationAreaRight').html('<p>R:</p>' + rightmessage);
        $('span.validationAreaLeft').html('<p>L:</p>' + leftmessage);

        if(!generalOK)
            $('span.validationAreaGeneral').show();
        if(!leftOK)
            $('span.validationAreaLeft').show();
        if(!rightOK)
            $('span.validationAreaRight').show();

        return generalOK && leftOK && rightOK;

    };

    function TriggerExportFormats() {
        $('.triggerExportFormatsMessage').html(window.Resources.SendingReport);
        $.ajax({
            type: 'POST',
            data: {
                orderUid: Model.OrderID,
                reportUid: Model.PartialReport_UID
            },
            url: '/legacy/Reports/TriggerReportExportFormats',
            dataType: 'json',
            success: function (data) {
                if (data.AllOk == true) {
                    $('.triggerExportFormatsMessage').html(window.Resources.ReportWasSentOn + " " + moment().format("DD/MM/YYYY hh:mm:ss A"))
                } else {
                    alert("Printing failed");
                    $('.triggerExportFormatsMessage').html("")
                }
            }
        });
    }

    $('input#btnTriggerExportFormats').on('click', function (e) {
        TriggerExportFormats();
    });

    $('input#btnSendToTranscription').on('click', function (e, fromEOL, dontCheckEmpty) {
        //CHECK G2
        if (typeof dontCheckEmpty == "undefined") {
            dontCheckEmpty = false;
        }
        if (typeof fromEOL == "undefined") {
            fromEOL = false;
        }
        if (!fromEOL && userHasSpeechRecognition && useG2Speech && !dontCheckEmpty) {

            clearTimeout(window.pollG2Timeout);

            $('#btnValidateAndCloseFile').attr('disabled', true);
            $('#btnSaveAndCloseFile').attr('disabled', true);

            closeActiveSpeech().done(function (e) {
                $('#btnValidateAndCloseFile').removeAttr('disabled');
                $('#btnSaveAndCloseFile').removeAttr('disabled');

                $.ajax({
                    type: "GET",
                    url: "/legacy/Reports/GetG2SpeechDocumentOnSaveAndClose",
                    async: false,
                    data: {
                        GUID: reportGUID,
                        submit: false,
                        Order_UID: Model.OrderID
                    },
                    timeout: 15000,
                    success: function (data) {
                        clearTimeout(window.pollG2Timeout);
                        if ((data.AllOk || (data.ErrorG2 && !data.SpeechDocumentExists && $('#editableContent').val() == "true")) && $('#editableContent').val() == "false") {
                            if (data.ReportGUID) {
                                reportGUID = data.ReportGUID;
                            }
                            $('#startSpeechRecognition').removeClass('disabled');
                            tinymce.activeEditor.setContent(data.Result);
                        }
                        else if (data.ErrorG2) {
                            $('#startSpeechRecognition').removeClass('disabled');
                            alert(data.ErrorMessage);
                            return false;
                        }
                        else if (data.Error) {
                            console.log('Error getting G2speechdocumentOnSaveAndClose');
                            $('#startSpeechRecognition').removeClass('disabled');
                        }

                        if (CheckReportContentBeforeSaving(dontCheckEmpty, 3)) {
                            if (showConfirmationOnSave) {
                                showConfirmationPopup(3);
                            }
                            else {
                                if (isAssistentRadiologist) {
                                    ShowPopupChooseSupervisor(false, true, true, false);
                                }
                                else {
                                    ValidateOrSaveAndClose(false, true, null, true, false, Model.OrderProcedures[0].Reviewer_UID);
                                }
                            }
                        }
                    }
                });
            }).error(function(e) {
                $('#btnValidateAndCloseFile').removeAttr('disabled');
                $('#btnSaveAndCloseFile').removeAttr('disabled');
            });

        }
        else {
            if (CheckReportContentBeforeSaving(dontCheckEmpty, 3)) {
                if (showConfirmationOnSave) {
                    showConfirmationPopup(3);
                }
                else {
                    if (isAssistentRadiologist) {
                        ShowPopupChooseSupervisor(false, true, true, false);
                    }
                    else {
                        ValidateOrSaveAndClose(false, true, null, true, false);
                    }
                }
            }
        }
    });

    function SendToPreliminary(e, fromEOL, dontCheckEmpty, triggerExportFormats) {

        triggerExportFormats = triggerExportFormats || false;

        //CHECK G2
        if (typeof dontCheckEmpty == "undefined") {
            dontCheckEmpty = false;
        }
        if (typeof fromEOL == "undefined") {
            fromEOL = false;
        }
        if (!fromEOL && userHasSpeechRecognition && useG2Speech && !dontCheckEmpty) {

            clearTimeout(window.pollG2Timeout);

            $('#btnValidateAndCloseFile').attr('disabled', true);
            $('#btnSaveAndCloseFile').attr('disabled', true);
            closeActiveSpeech().done(function (e) {
                $('#btnValidateAndCloseFile').removeAttr('disabled');
                $('#btnSaveAndCloseFile').removeAttr('disabled');
                $.ajax({
                    type: "GET",
                    url: "/legacy/Reports/GetG2SpeechDocumentOnSaveAndClose",
                    async: false,
                    data: {
                        GUID: reportGUID,
                        submit: false,
                        Order_UID: Model.OrderID
                    },
                    timeout: 15000,
                    success: function (data) {
                        clearTimeout(window.pollG2Timeout);
                        if ((data.AllOk || (data.ErrorG2 && !data.SpeechDocumentExists && $('#editableContent').val() == "true")) && $('#editableContent').val() == "false") {
                            if (data.ReportGUID) {
                                reportGUID = data.ReportGUID;
                            }
                            $('#startSpeechRecognition').removeClass('disabled');
                            tinymce.activeEditor.setContent(data.Result);
                        }
                        else if (data.ErrorG2) {
                            $('#startSpeechRecognition').removeClass('disabled');
                            alert(data.ErrorMessage);
                            return false;
                        }
                        else if (data.Error) {
                            console.log('Error getting G2speechdocumentOnSaveAndClose');
                            $('#startSpeechRecognition').removeClass('disabled');
                        }

                        if (CheckReportContentBeforeSaving(dontCheckEmpty, 4)) {
                            if (showConfirmationOnSave) {
                                showConfirmationPopup(4);
                            }
                            else {
                                if (isAssistentRadiologist) {
                                    ShowPopupChooseSupervisor(false, true, false, true, triggerExportFormats);
                                }
                                else {
                                    ValidateOrSaveAndClose(false, true, null, false, true, triggerExportFormats);
                                }
                            }
                        }
                    }
                });
            }).error(function(e) {
                $('#btnValidateAndCloseFile').removeAttr('disabled');
                $('#btnSaveAndCloseFile').removeAttr('disabled');
            });

        }
        else {
            if (CheckReportContentBeforeSaving(dontCheckEmpty, 4)) {
                if (showConfirmationOnSave) {
                    showConfirmationPopup(3);
                }
                else {
                    if (isAssistentRadiologist) {
                        ShowPopupChooseSupervisor(false, true, false, true, triggerExportFormats);
                    }
                    else {
                        ValidateOrSaveAndClose(false, true, null, false, true, triggerExportFormats);
                    }
                }
            }
        }
    }

    $('input#btnSendToPreliminary').on('click', function (e, fromEOL, dontCheckEmpty) {
        gTriggerExportFormats = false;
        SendToPreliminary(e, fromEOL, dontCheckEmpty, gTriggerExportFormats);
    });

    $('input#btnSendToPreliminaryAndTriggerExportFormats').on('click', function (e, fromEOL, dontCheckEmpty) {
        gTriggerExportFormats = true;
        SendToPreliminary(e, fromEOL, dontCheckEmpty, gTriggerExportFormats);
    });

    $('input#btnSaveAndCloseFile').on('click', function (e, fromEOL, dontCheckEmpty) {
        if (screening) {
            $('span.validationAreaGeneral').hide();
            $('span.validationAreaLeft').hide();
            $('span.validationAreaRight').hide();
            if(!ValidateScreeningInputFields())
            {
                $("#screeningvalidationdiv")[0].scrollIntoView(true);
                return;
            }
            if (!noRequestForm)
            {
                if(!ValidateRequestFormInputFields(true))
                {
                    $('a[href="#requestTab"]').trigger('click');
                    $("#request #validationdiv")[0].scrollIntoView(true);
                    return;
                }
            }
        }
        //CHECK G2
        if (typeof dontCheckEmpty == "undefined") {
            dontCheckEmpty = false;
        }
        if (typeof fromEOL == "undefined") {
            fromEOL = false;
        }

        if (!fromEOL && userHasSpeechRecognition && useG2Speech && !dontCheckEmpty && !screening) {

            clearTimeout(window.pollG2Timeout);

            $('#btnValidateAndCloseFile').attr('disabled', true);
            $('#btnSaveAndCloseFile').attr('disabled', true);

            closeActiveSpeech().done(function (e) {

                $('#btnValidateAndCloseFile').removeAttr('disabled');
                $('#btnSaveAndCloseFile').removeAttr('disabled');

                $.ajax({
                    type: "GET",
                    url: "/legacy/Reports/GetG2SpeechDocumentOnSaveAndClose",
                    async: false,
                    data: {
                        GUID: reportGUID,
                        Order_UID: Model.OrderID
                    },
                    timeout: 15000,
                    success: function (data) {
                        clearTimeout(window.pollG2Timeout);

                        if ((data.AllOk || (data.ErrorG2 && !data.SpeechDocumentExists && $('#editableContent').val() == "true")) && $('#editableContent').val() == "false") {
                            if (data.ReportGUID) {
                                reportGUID = data.ReportGUID;
                            }
                            $('#startSpeechRecognition').removeClass('disabled');
                            tinymce.activeEditor.setContent(data.Result);
                        }
                        else if (data.ErrorG2) {
                            $('#startSpeechRecognition').removeClass('disabled');
                            alert(data.ErrorMessage);
                            return false;
                        }

                        if (CheckReportContentBeforeSaving(dontCheckEmpty, 1)) {
                            if (showConfirmationOnSave) {
                                showConfirmationPopup(2);
                            }
                            else {
                                if (isAssistentRadiologist) {
                                    ShowPopupChooseSupervisor(false, true, false, false);
                                }
                                else {
                                    ValidateOrSaveAndClose(false, true, null, false, false, Model.OrderProcedures[0].Reviewer_UID);
                                }
                            }
                        }
                    }
                });
            }).error(function(e) {
                $('#btnValidateAndCloseFile').removeAttr('disabled');
                $('#btnSaveAndCloseFile').removeAttr('disabled');
            });

        }
        else {
            if (CheckReportContentBeforeSaving(dontCheckEmpty, 1)) {
                if (showConfirmationOnSave) {
                    showConfirmationPopup(2);
                }
                else {
                    if (isAssistentRadiologist) {
                        ShowPopupChooseSupervisor(false, true, false, false);
                    }
                    else {
                        ValidateOrSaveAndClose(false, true, null, false, false, Model.OrderProcedures[0].Reviewer_UID);
                    }
                }
            }
        }
        $('body').off('click', 'ul.listFound li');
    });

    $('input#btnValidateAndCloseFile').on('click', function (e, fromEOL, dontCheckEmpty) {
        if (screening) {
            $('span.validationAreaGeneral').hide();
            $('span.validationAreaLeft').hide();
            $('span.validationAreaRight').hide();
            if(!ValidateScreeningInputFields())
            {
                $("#screeningvalidationdiv")[0].scrollIntoView(true);
                return;
            }
            if (!noRequestForm)
            {
                if(!ValidateRequestFormInputFields(true))
                {
                    $('a[href="#requestTab"]').trigger('click');
                    $("#request #validationdiv")[0].scrollIntoView(true);
                    return;
                }
            }
        }
        //CHECK G2
        if (typeof dontCheckEmpty == "undefined") {
            dontCheckEmpty = false;
        }
        if (typeof fromEOL == "undefined") {
            fromEOL = false;
        }

        if (!fromEOL && userHasSpeechRecognition && useG2Speech && !dontCheckEmpty && !screening) {
            clearTimeout(window.pollG2Timeout);

            $('#btnValidateAndCloseFile').attr('disabled', true);
            $('#btnSaveAndCloseFile').attr('disabled', true);

            closeActiveSpeech().done(function (e) {
                $('#btnValidateAndCloseFile').removeAttr('disabled');
                $('#btnSaveAndCloseFile').removeAttr('disabled');
                $.ajax({
                    type: "GET",
                    url: "/legacy/Reports/GetG2SpeechDocumentOnSaveAndClose",
                    async: false,
                    data: {
                        GUID: reportGUID,
                        Order_UID: Model.OrderID
                    },
                    timeout: 15000,
                    success: function (data) {
                        clearTimeout(window.pollG2Timeout);

                        if ((data.AllOk || (data.ErrorG2 && !data.SpeechDocumentExists && $('#editableContent').val() == "true")) && $('#editableContent').val() == "false") {
                            if (data.ReportGUID) {
                                reportGUID = data.ReportGUID;
                            }
                            $('#startSpeechRecognition').removeClass('disabled');
                            tinymce.activeEditor.setContent(data.Result);
                            //$('#editableContent').val("false");
                        }
                        else if (data.ErrorG2) {
                            $('#startSpeechRecognition').removeClass('disabled');
                            alert(data.ErrorMessage);
                            return false;
                        }

                        // CHECK EMPTY REPORT
                        if (CheckReportContentBeforeSaving(dontCheckEmpty, 2)) {
                            if (showConfirmationOnValidate) {
                                showConfirmationPopup(1);
                            }
                            else {
                                if (isAssistentRadiologist) {
                                    ShowPopupChooseSupervisor(true, true, false, false);
                                }
                                else {
                                    if (userRadiologistId != 0 && Model.SupervisorId != null && userRadiologistId !== Model.SupervisorId) {
                                        ShowPopupSetCurrentRadiologistAsSupervisor(true, true, false, false)
                                    }
                                    else {
                                        ValidateOrSaveAndClose(true, true, null, false, false);
                                    }
                                }
                            }
                        }
                    }
                });
            }).error(function(e) {
                $('#btnValidateAndCloseFile').removeAttr('disabled');
                $('#btnSaveAndCloseFile').removeAttr('disabled');
            });;

        }
        else {
            if (CheckReportContentBeforeSaving(dontCheckEmpty, 2)) {
                if (showConfirmationOnValidate) {
                    showConfirmationPopup(1);
                }
                else {
                    if (isAssistentRadiologist) {
                        ShowPopupChooseSupervisor(true, true, false, false);
                    }
                    else {
                        if (userRadiologistId != 0 && Model.SupervisorId != null && userRadiologistId !== Model.SupervisorId) {
                            ShowPopupSetCurrentRadiologistAsSupervisor(true, true, false, false)
                        }
                        else {
                            ValidateOrSaveAndClose(true, true, null, false, false);
                        }
                    }
                }
            }
        }
        $('body').off('click', 'ul.listFound li');
    });

    $('input#verifyNomenclatures').on('click', function (e) {
        showConfirmationPopup(5);
    });

    $('span.validation').hide();

    $('span.validationAreaGeneral').hide();
    $('span.validationAreaLeft').hide();
    $('span.validationAreaRight').hide();

    $('h3.panelHeaderPassive').next().hide();

    var m = moment($('dd#age').html(), "DD/MM/YYYY");
    if (m.isValid()) {
        $('dd#age').html(moment().diff(m, 'years'));
    }

    $('a[href="#"]').on('click', function (e) {
        e.preventDefault();
    });

    $('select').each(function (e) {
        if ($(this).attr('value') != null) {
            $(this).val($(this).attr('value'));
        }
    });

    $('textarea').each(function (e) {
        if ($(this).attr('value') != null) {
            $(this).val($(this).attr('value'));
        }
    });

    function ResizeTopSubField(e) {
        var subField = $('form#addOrderForm').find('div.subField').first();
        var width = subField.width();
        var imageHolder = subField.find('div#imageHolder');
        var personalInfo = subField.find('div#personalInfo');
        personalInfo.width(width - imageHolder.width() - 20);
    }


    ResizeTopSubField();



    $('dd#publicRemarksShow').on('click', function (e) {
        e.stopImmediatePropagation();
        if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $(this).text(window.Resources.ClickToOpen + '...');
            $('#dialogPublicRemarks' + viewbagUniquePrefix).dialog("close");
        }
        else {
            $(this).addClass('open');
            $(this).text(window.Resources.ClickToClose + '...');
            $('#dialogPublicRemarks' + viewbagUniquePrefix).dialog("open");
        }
    });



    $('dd#privateRemarksShow').on('click', function (e) {
        if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $(this).text(window.Resources.ClickToOpen + '...');
            $('#dialogPrivateRemarks' + viewbagUniquePrefix).dialog("close");
        }
        else {
            $(this).addClass('open');
            $(this).text(window.Resources.ClickToClose + '...');
            $('#dialogPrivateRemarks' + viewbagUniquePrefix).dialog("open");
        }
    });

    $('dd#publicRemarksShow').removeClass('open');
    $('dd#publicRemarksShow').text(window.Resources.ClickToOpen + '...');
    $('dd#privateRemarksShow').removeClass('open');
    $('dd#privateRemarksShow').text(window.Resources.ClickToOpen + '...');







    $('input[type=radio]').on('change', function (e) {
        var thisVal = $(this).val();
        $(this).attr('checked', true);
        $('input[type=radio][name=' + $(this).attr('name') + ']').each(function (i, y) {
            if ($(y).val() != thisVal) {
                $(y).removeAttr('checked');
            }
        });
    });

    $('input#viewHistoryPatient').on('click', function (e) {
        useFilingCabinet("/Patients/OrderHistory/" + Model.PatientID);
    });

    $('input#loadOrder').on('click', function (e) {
        useFilingCabinet("/Orders/Detail/" + Model.OrderID);
    });

    $('body').on('mouseenter', 'div#orderHistoryTimeline li ul, div#orderHistoryTimeline li.yearItem span.amount', function (e) {
        $(this).parent().addClass('hoverItem');
    });
    $('body').on('mouseleave', 'div#orderHistoryTimeline li ul, div#orderHistoryTimeline li.yearItem span.amount', function (e) {
        $(this).parent().removeClass('hoverItem');
    });

    $('div#submitBottom').find('div#orderHistoryTimeline, div#noOrderHistoryTimeline').remove();

    $('div#contentView').show();

    $('body').on('click', 'li.filterHistory', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        if ($(e.target).hasClass('check-box')) {
        }
        else {
            var chkBox = $(this).find('input[type=checkbox]');
            chkBox.prop("checked", !chkBox.prop("checked"));
            chkBox.attr("checked", chkBox.prop('checked'));
            if (chkBox.attr('id') == "checkModality") {
                CheckedFilterModality = chkBox.prop('checked');
            }
            else if (chkBox.attr('id') == "checkProcedures") {
                CheckedFilterProcedures = chkBox.prop('checked');
            }

            GetOrderHistory();
        }
    });

    $('body').on('click', 'li.filterHistory input.check-box', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        $(this).attr('checked', $(this).prop('checked'));

        if ($(this).attr('id') == "checkModality") {
            CheckedFilterModality = $(this).prop('checked');
        }
        else if ($(this).attr('id') == "checkProcedures") {
            CheckedFilterProcedures = $(this).prop('checked');
        }

        GetOrderHistory();
    });

    $('body').on('click', 'input#openPreviousReport', function (e) {
        e.stopImmediatePropagation();
        var reportID = $('#openPreviousReportUID').val();
        var orderID = $('#openPreviousReportOrderUID').val();
        if (reportID != 0 && orderID != 0) {
            useFilingCabinet('/Reports/ProcedureCombinationPartialReport/' + orderID + '?Report_UID=' + reportID);
        }
    });


    $('body').on('click', 'li.yearItem', function (e) {
        e.stopImmediatePropagation();
        var year = $(this).find('span.title').text();
        var firstOfYear = $('ul#orderHistoryList').find('li.' + year).first();
        if (firstOfYear.length !== 0) {
            var offset = firstOfYear[0].offsetLeft;
            $("#orderHistoryContainer").mCustomScrollbar("scrollTo", offset);
        }
    });



    GetOrderHistory();

    var startDragg = 0;
    $('body').on('mousedown', '#orderHistoryTimeline #orderHistoryContainer', function (e) {
        scrollingOverOrders = true;
        try {
            startDragg = -mcs.left;
        } catch (e) { }
        e.preventDefault();
        $(this)
            .data('down', true) // a flag indicating the mouse is down
            .data('x', e.clientX) // the current mouse down X coord
            .data('scrollLeft', this.scrollLeft); // the current scroll position
        return false;
    });

    $('body').on('mousedown', '#orderHistoryTimeline #yearHistoryContainer', function (e) {
        e.preventDefault();
        $(this)
            .data('down', true) // a flag indicating the mouse is down
            .data('x', e.clientX) // the current mouse down X coord
            .data('scrollLeft', this.scrollLeft); // the current scroll position
        return false;
    });

    $('body').on('mouseup', function (e) {
        var containerOrders = $('#orderHistoryTimeline #orderHistoryContainer');
        $(containerOrders).data('down', false);
        scrollingOverOrders = false;
        var containerYears = $('#orderHistoryTimeline #yearHistoryContainer');
        $(containerYears).data('down', false);
    });

    $('body').on('mousemove', function (e) {
        var containerOrders = $('#orderHistoryTimeline #orderHistoryContainer');
        if (containerOrders.data('down') == true) {
            $("#orderHistoryContainer").mCustomScrollbar("scrollTo", startDragg + (containerOrders.data('x') - e.clientX), {
                scrollInertia: 10
            });
        }
        var containerYears = $('#orderHistoryTimeline #yearHistoryContainer');
        if (containerYears.data('down') == true) {
            containerYears[0].scrollLeft = containerYears.data('scrollLeft') + containerYears.data('x') - e.clientX;
        }
    });

    //Firefox
    $('#orderHistoryTimeline #orderHistoryContainer').bind('DOMMouseScroll', function (e) {
        if (e.originalEvent.detail > 0) {
            ScrollRightOrders();
        } else {
            ScrollLeftOrders();
        }
        return false;
    });
    $('#orderHistoryTimeline #yearHistoryContainer').bind('DOMMouseScroll', function (e) {
        if (e.originalEvent.detail > 0) {
            ScrollRightYears();
        } else {
            ScrollLeftYears();
        }
        return false;
    });

    function ScrollLeftOrders(e) {
        try {
            $("#orderHistoryContainer").mCustomScrollbar("scrollTo", "-=180", {
                scrollInertia: 10
            });
        }
        catch (e) { }
    }
    function ScrollLeftYears(e) {
        $("#orderHistoryTimeline #yearHistoryContainer").finish();
        $("#orderHistoryTimeline #yearHistoryContainer").animate({
            scrollLeft: "-=150"
        }, 450);
    }

    function ScrollRightOrders(e) {
        try {
            $("#orderHistoryContainer").mCustomScrollbar("scrollTo", "+=180", {
                scrollInertia: 10
            });
        }
        catch (e) { }
    }
    function ScrollRightYears(e) {
        $("#orderHistoryTimeline #yearHistoryContainer").finish();
        $("#orderHistoryTimeline #yearHistoryContainer").animate({
            scrollLeft: "+=150"
        }, 450);
    }
    //$('div#subPageContent').height($('div#content').height() - 20 - $('div#submitBottom').height());
    setTimeout(function () {
        if ($('div#subContent').find('div#submitBottom').length > 0) {
            $('div#subPageContent').height($('div#content').height() - 20 - $('div#submitBottom').height());
        }
        ResizeTopSubField();
        $("#orderHistoryContainer").mCustomScrollbar("update");
    }, 300);

    $('#loading').hide();

    $(window).resize(function (e) {
        setTimeout(function (e) {
            ResizeTopSubField();
            $("#orderHistoryContainer").mCustomScrollbar("update");
        }, 300);

    });

    $('#procNotInReport li.procedureItem, #procNotInReport li.procedureItemWithRating, #procNotInReport li.procedureItemWithRatingv1').hoverIntent({
        sensitivity: 3,
        interval: 200,
        timeout: 200,
        over: function (e) {
            var titlePopup = $(this).find('.insideProcedureItemContainer').text() + $("<div/>").html(window.Resources.OthersInOrder).text();
            var reportID = $(this).find('span.procHasReportID').text();
            ReportSharedFunctions.ShowPreviousReportPopup(reportID, titlePopup, viewbagUniquePrefix, screening, false);
        },
        out: function (e) { }
    });

    $('div.productsInReport').on('click', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        $('li#openProductsTab a').trigger('click');
    });

    //CHECKS

    function CheckReportDictatedForChecks(orderID) {
        var allChecked = true;
        $.ajax({
            type: "GET",
            url: "/legacy/Orders/CheckDictatedChecks",
            async: false,
            data: {
                Order_UID: orderID
            },
            success: function (data) {
                if (data.AllOk) {
                    allChecked = data.AllChecked;

                    if (data.Checks.length != 0 && !data.AllChecked) {
                        $('#checksTable tr.checkRecord').remove();
                        $('#extraInformationChecks').empty();

                        $.each(data.Checks, function (i, check) {
                            $('#checksTable').append(createCheckRow(check));
                        });
                        $('#GroupChecks').prop("checked", false);
                        checkCheckGrouping();
                        $('#divPopupConfirmationChecksRemaining').find('span.validation').hide();
                        $('#divPopupConfirmationChecksRemaining').dialog('open');
                    }
                }
                else {
                    if (data.Error) {
                        console.log('Error checking dictated checks: ' + data.Message);
                    }
                }
            }
        });
        return allChecked;
    }

    $('#btnSaveChecks').on('click', function (e) {
        //check if all obligatory checks are set
        checkModels = [];

        var allObligatoryChecked = true;
        $('#checksTable tr.checkRecord').each(function (i, row) {
            // reference all the stuff you need first
            var row = $(row);
            var checked = row.find('input.checkChecked').is(':checked');
            var obligatory = row.find('input.obligatory').val() == 'true';
            var obligatoryForStatus = row.find('input.requiredToChangeToStatusStatus').val();
            var remark = row.find('textarea.checkremarkText').text();

            var checkModel = {
                Entity_HasCheck_UID: row.find('input.checkGUID').val(),
                Checked: row.find('input.checkChecked').is(':checked'),
                Unit: row.find('input.unitValue').val(),
                TextValue: row.find('input.textValue').val(),
                TextValue2: row.find('input.textValue2').val(),
                DateValue: row.find('input.dateValue').val(),
                DropDownValue: row.find('select.dropdownValue').find(':selected').val(),
                CheckedBy_UID: row.find('input.checkByUID').val(),
                Check_UID: row.find('input.checkUID').val(),
                CheckRemarks: row.find('textarea.checkremarkText').text(),
                IsGrouped: row.find('input.isGrouped').val(),
                IsGroupMaster: row.find('input.isGroupMaster').val(),
                IsGroupSlave: row.find('input.isGroupSlave').val(),
                RoomUID: row.find('input.roomUID').val(),
                RoomText: row.find('input.roomText').val()
            };
            checkModels.push(checkModel);

            if((checkModel.IsGrouped == 'true' && checkModel.IsGroupMaster == 'true') || checkModel.IsGrouped == 'false')
            {
                //only check when the record is a Master or there is no grouping at all
                if ((!checked && obligatory) && ($.trim(remark) == "" && obligatory) && 5 >= obligatoryForStatus) {
                    allObligatoryChecked = false;
                }
            }

        });
        if (!allObligatoryChecked) {
            //give error
            $('#divPopupConfirmationChecksRemaining').find('span.validation').show();
            $('#divPopupConfirmationChecksRemaining').find('span.validation').text(window.ErrorStrings.CheckAllChecks);
        }
        else {
            UpdateChecks();
            $('#divPopupConfirmationChecksRemaining').dialog('close');
            ValidateOrSaveAndCloseFunctionality(gValidated, gClose, gSupervisor_uid, gTranscription, gPreliminary, gTriggerExportFormats, gReviewer_uid);
        }
    });

    function UpdateChecks(e) {
        $.ajax({
            url: "/legacy/Json/UpdateChecksForOrder",
            type: "POST",
            dataType: "json",
            traditional: true,
            data: {
                Checks: JSON.stringify(checkModels)
            },
            success: function (data) {
                if (data.Error) {
                    alert('Error updating checks: ' + data.Message);
                }
            }
        });
        checkModels = [];
    }

    function createCheckRow(ch) {
        var rowToAppend = $('<tr class="record' + ch.Entity_HasCheck_UID + ' checkRecord"></tr>');
        var cellsToAppend;

        cellsToAppend += '<td class="center pr5 center checkbox">';
        if (ch.Checked) {
            cellsToAppend += '<input type="checkbox" class="checkChecked check-box" checked="checked" name="Checks[0].Checked" value="true" />';
        }
        else {
            cellsToAppend += '<input type="checkbox" class="checkChecked check-box" name="Checks[0].Checked" />';
        }

        cellsToAppend += '<input type="hidden" class="checkGUID" name="Checks[0].GUID" value="' + ch.Entity_HasCheck_UID + '" />';
        cellsToAppend += '<input type="hidden" class="obligatory" name="Checks[0].Obligatory" value="' + ch.Obligatory + '" />';
        cellsToAppend += '<input type="hidden" class="requiredToChangeToStatus" name="Checks[0].CheckRequiredToChangeToStatus" value="' + ch.CheckRequiredToChangeToStatus + '" />';
        cellsToAppend += '<input type="hidden" class="requiredToChangeToStatusStatus" name="Checks[0].CheckRequiredToChangeToStatusStatus" value="' + ch.CheckRequiredToChangeToStatusStatus + '" />';
        cellsToAppend += '<input type="hidden" class="isGrouped" name="Checks[0].IsGrouped" value="' + ch.IsGrouped + '" />';
        cellsToAppend += '<input type="hidden" class="isGroupMaster" name="Checks[0].IsGroupMaster" value="' + ch.IsGroupMaster + '" />';
        cellsToAppend += '<input type="hidden" class="isGroupSlave" name="Checks[0].IsGroupSlave" value="' + ch.IsGroupSlave + '" />';
        cellsToAppend += '<input type="hidden" class="roomUID" name="Checks[0].RoomUID" value="' + ch.RoomUID + '" />';
        cellsToAppend += '<input type="hidden" class="roomText" name="Checks[0].RoomText" value="' + ch.RoomText + '" />';
        cellsToAppend += '</td>';
        cellsToAppend += '<td class="pr20 checkName" title="' + ch.CheckDescription + '">';
        cellsToAppend += ch.CheckName;
        cellsToAppend += '<input type="hidden" class="checkName" readonly="readonly" name="Checks[0].CheckName" value="' + ch.CheckName + '" />';
        cellsToAppend += '<input type="hidden" class="checkDescription" name="Checks[0].CheckDescription" value="' + ch.CheckDescription + '" />';
        cellsToAppend += '<input type="hidden" class="checkUID" name="Checks[0].Check_UID" value="' + ch.Check_UID + '" />';
        cellsToAppend += '</td>';
        cellsToAppend += '<td class="pr40">';
        cellsToAppend += '<input type="hidden" class="checkType" name="Checks[0].TypeCode" value="' + ch.TypeCode + '" />';
        switch (ch.TypeCode) {
            case "DDL":
                cellsToAppend += '<select class="dropdownValue">';
                $.each(ch.DropDownChoices, function (i, choice) {
                    cellsToAppend += '<option value="' + choice.Value + '">' + choice.Text + '</option>';
                });
                cellsToAppend += '</select>';
                break;
            case "FU":
                cellsToAppend += '<input class="textValue" name="Checks[0].TextValue" type="text" value="' + ch.TextValue + '">';
                cellsToAppend += '<input class="unitValue" disabled name="Checks[0].Unit" type="text" value="' + ch.Unit + '">';
                break;
            case "FUD":
                cellsToAppend += '<input class="textValue" name="Checks[0].TextValue" type="text" value="' + ch.TextValue + '">';
                cellsToAppend += '<input class="unitValue" disabled name="Checks[0].Unit" type="text" value="' + ch.Unit + '">';
                cellsToAppend += '<input class="dateValue" placeholder="dd/mm/yyyy" name="Checks[0].DateValue" type="text" value="' + ch.DateValue + '">';
                break;
            case "FUF":
                cellsToAppend += '<input class="textValue" name="Checks[0].TextValue" type="text" value="' + ch.TextValue + '">';
                cellsToAppend += '<input class="unitValue" disabled name="Checks[0].Unit" type="text" value="' + ch.Unit + '">';
                cellsToAppend += '<input class="textValue2" name="Checks[0].TextValue2" type="text" value="' + ch.TextValue2 + '">';
                break;
        }
        cellsToAppend += '</td>';

        cellsToAppend += '<td class="pr15 checkedBy">';
        cellsToAppend += '<input type="text" class="checkByText" readonly="readonly" name="Checks[0].CheckedBy" value="' + ch.CheckedBy + '" />';
        cellsToAppend += '<input type="hidden" class="checkByUID" name="Checks[0].CheckedBy_UID" value="' + ch.CheckedBy_UID + '" />';
        cellsToAppend += '</td>';
        cellsToAppend += '<td class="pr5 editRemark">';
        cellsToAppend += '<input type="hidden" class="checkremarkUID" name="Checks[0].CheckRemark_UID" value="' + ch.Entity_HasCheck_UID + '">&nbsp;';
        cellsToAppend += '<input type="hidden" class="checkremarkCopyToPatient" name="Checks[0].CopyCheckRemarksToPatient" value="' + ch.CopyCheckRemarksToPatient + '">&nbsp;';
        cellsToAppend += '<input type="hidden" class="checkremarkCopyToOrder" name="Checks[0].CopyCheckRemarksToOrder" value="' + ch.CopyCheckRemarksToOrder + '">&nbsp;';
        cellsToAppend += '<textarea class="text-box clearfix checkremarkText" name="Checks[0].CheckRemarks" value="" cols="30" rows="5" style="display:none">';
        cellsToAppend += ch.CheckRemarks;
        cellsToAppend += '</textarea>';
        cellsToAppend += '</td>';
        if (ch.FromProcedureCode != null) {
            cellsToAppend += '<td class="pr10 center fromProcedure" style="background-color: ' + ch.FromProcedureColor + ';" title="' + ch.FromProcedureDescription + '">';
            cellsToAppend += '<span class="fromProcedureInfo"><b>' + ch.FromProcedureModality + '</b> <span>' + ch.FromProcedureCode + '</span></span>';
            cellsToAppend += '<input type="hidden" class="checkFromProcedureUID" name="Checks[0].FromProcedure_UID" value="' + ch.FromProcedure_UID + '" />';
            cellsToAppend += '<input type="hidden" class="checkFromProcedureModality" name="Checks[0].FromProcedureModality" value="' + ch.FromProcedureModality + '" />';
            cellsToAppend += '<input type="hidden" class="checkFromProcedureCode" name="Checks[0].FromProcedureCode" value="' + ch.FromProcedureCode + '" />';
            cellsToAppend += '<input type="hidden" class="checkFromProcedureColor" name="Checks[0].FromProcedureColor" value="' + ch.FromProcedureColor + '" />';
            cellsToAppend += '<input type="hidden" class="checkFromProcedureDescription" name="Checks[0].FromProcedureDescription" value="' + ch.FromProcedureDescription + '" />';
            cellsToAppend += '</td>';
        }
        else {
            cellsToAppend += '<td class="pr10 center">&nbsp;</td>';
        }

        rowToAppend.html(cellsToAppend);

        return rowToAppend;
    }

    function checkCheckGrouping(e) {
        var isGrouped = false;

        $('#checksTable tr').each(function (i, row) {
            var row = $(row);
            var checkModel = {
                IsGrouped: row.find('input.isGrouped').val()
            };

            if (checkModel.IsGrouped == "true") {
                isGrouped = true;
                return false;
            }
        });
        if (isGrouped) {
            $('#GroupChecks').trigger('click');
        }
    }

    $('button#btnCloseSetCheckedBy').on('click', function (e) {
        $('#divSetCheckedBy').dialog("close");

        var forcheck = $('#forCheckSetBy').val();
        $('tr.record' + forcheck + ' input.checkChecked').attr('checked', '');
        $('tr.record' + forcheck + ' input.checkChecked').prop('checked', false);
        $('tr.record' + forcheck + ' input.checkChecked').val(false);
    });

    $('button#btnSaveAndCloseSetCheckedBy').on('click', function (e) {
        var forcheck = $('#forCheckSetBy').val();

        var divHolder = $('#divSetCheckedBy');
        var validation = divHolder.find('span.validation');

        var user = $('#divSetCheckedBy #setCheckedByUser').val();
        var useruid = $('#divSetCheckedBy #setCheckedByUserUID').val();

        if ($.trim(user) == "" || $.trim(useruid) == "") {
            validation.show();
            validation.text(window.ErrorStrings.ErrorSelectUser);
            return false;
        }

        $('tr.record' + forcheck + ' input.checkChecked').attr('checked', 'checked');
        $('tr.record' + forcheck + ' input.checkChecked').prop('checked', true);
        $('tr.record' + forcheck + ' input.checkChecked').val(true);

        $('tr.record' + forcheck + ' input.checkByText').val(user);
        $('tr.record' + forcheck + ' input.checkByUID').val(useruid);

        window.ChecksDialog.leavechecked = true;

        $('#divSetCheckedBy').dialog("close");

    });

    $('input#setCheckedByUser').autocomplete({
        autoFocus: true,
        source: function (request, response) {
            $.ajax({
                url: "/legacy/Json/AutoCompleteUsers",
                type: "GET",
                dataType: "json",
                data: {
                    term: request.term
                },
                success: function (data) {
                    response($.map(data, function (item) {
                        return {
                            label: item.FullText,
                            value: item.FullText,
                            id: item.ID
                        };
                    }))
                }
            })
        },
        minLength: 0,
        select: function (event, ui) {
            $(this).parent().find('#setCheckedByUserUID').val(ui.item.id);
            $(this).parent().find('#setCheckedByUser').attr('value', ui.item.value);
        }
    });

    $('body').on('click', '#checksTable td.editRemark', function (e) {
        e.stopImmediatePropagation();
        if (!$('div#subPageContent').hasClass('disabled')) {
            var forchecked = $(this).find('.checkremarkUID').val();
            var remark = $(this).find('.checkremarkText').text();

            $('#divSetRemarks').find('#forCheckRemark').val(forchecked);

            $('#divSetRemarks #setRemark').val(remark);

            $('#divSetRemarks').find('span.validation').hide();

            $.ajax({
                type: "GET",
                url: '/legacy/System/GetLoggedInUser',
                data: {},
                dataType: 'json',
                async: false,
                success: function (data) {
                    if (data.AllOk) {
                        $('#divSetRemarks').find('#setRemarkByUser').val(data.Username);
                        $('#divSetRemarks').find('#setRemarkByUser').attr('value', data.Username);
                        $('#divSetRemarks').find('#setRemarkByUserUID').val(data.UserUID);
                        $('#divSetRemarks').find('#setRemarkByUserUID').attr('value', data.UserUID);
                    }
                }
            });

            $('#divSetRemarks').dialog("open");
        }
    });
    $('#btnSaveAndCloseSetRemark').on('click', function (e) {
        e.stopImmediatePropagation();
        var forcheck = $('#forCheckRemark').val();

        var divHolder = $('#divSetRemarks');
        var validation = divHolder.find('span.validation');

        var remark = $('#divSetRemarks #setRemark').val();

        $('tr.record' + forcheck + ' textarea.checkremarkText').text(remark);

        var user = $('#divSetRemarks #setRemarkByUser').val();
        var useruid = $('#divSetRemarks #setRemarkByUserUID').val();

        if ($.trim(user) == "" || $.trim(useruid) == "") {
            validation.show();
            validation.text(window.ErrorStrings.ErrorSelectUser);
            return false;
        }

        if ($.trim(remark) == "" && !$('tr.record' + forcheck + ' input.checkChecked').is(':checked')) {
            $('tr.record' + forcheck + ' input.checkByText').val("");
            $('tr.record' + forcheck + ' input.checkByUID').val(0);
        }
        else {
            $('tr.record' + forcheck + ' input.checkByText').val(user);
            $('tr.record' + forcheck + ' input.checkByUID').val(useruid);
        }

        var copytoorder = $('tr.record' + forcheck + ' input.checkremarkCopyToOrder').val() == 'True';
        var copytopatient = $('tr.record' + forcheck + ' input.checkremarkCopyToPatient').val() == 'True';

        if (copytoorder) {
            $('textarea#Remarks').val($('textarea#Remarks').val() + '<br />' + remark);
        }
        if (copytopatient) {
            $('div#remarksDiv div.patientRemarksHolder span.publicRemarks').text($('div#remarksDiv div.patientRemarksHolder span.publicRemarks').text() + '<br />' + remark);
        }

        $('#divSetRemarks').dialog("close");
    });

    $('button#btnCloseSetRemark').on('click', function (e) {
        $('#divSetRemarks').dialog("close");
    });

    //GROUPING
    var roomHasCheckTypes = {};

    function groupChecks(e) {
        var rooms = [];
        //Group the checks on hall
        $('#checksTable tr').each(function (i, row) {
            var row = $(row);
            var checkModel = buildCheckModelForRow(row);

            //Not yet grouped
            if ($.inArray(checkModel.Room_UID, rooms) != -1) {
                //room already in groups
                var checkTypes = roomHasCheckTypes[checkModel.Room_UID];

                if (typeof checkTypes === 'undefined') {
                    //possible when postback on edit
                    checkTypes = [];
                }

                if ($.inArray(checkModel.Check_UID, checkTypes) != -1) {
                    //Check already has a groupMaster, make row a slave
                    row.hide();
                    //set grouped
                    row.find('input.isGrouped').val(true);
                    row.find('input.isGroupMaster').val(false);
                    row.find('input.isGroupSlave').val(true);
                }
                else {
                    //Make row a groupMaster
                    checkTypes.push(checkModel.Check_UID);
                    roomHasCheckTypes[checkModel.Room_UID] = checkTypes;

                    //set roomname
                    row.find('td.fromProcedure').removeAttr('style');
                    row.find('span.fromProcedureInfo').empty();
                    row.find('span.fromProcedureInfo').append('<span>' + checkModel.Room_Text + '</span>');

                    //set grouped
                    row.find('input.isGrouped').val(true);
                    row.find('input.isGroupMaster').val(true);
                    row.find('input.isGroupSlave').val(false);
                }
            }
            else {
                //new room
                var checkTypes = [];
                //Make row a groupMaster

                checkTypes.push(checkModel.Check_UID);
                roomHasCheckTypes[checkModel.Room_UID] = checkTypes;

                //set roomname
                row.find('td.fromProcedure').removeAttr('style');
                row.find('span.fromProcedureInfo').empty();
                row.find('span.fromProcedureInfo').append('<span>' + checkModel.Room_Text + '</span>');

                //set grouped
                row.find('input.isGrouped').val(true);
                row.find('input.isGroupMaster').val(true);
                row.find('input.isGroupSlave').val(false);

                rooms.push(checkModel.Room_UID);
            }
        });
    }

    function deGroupChecks(e) {
        rooms = [];
        roomHasCheckTypes = {};

        //Degroup the checks, so all of them are individualy shown
        $('#checksTable tr').each(function (i, row) {
            var row = $(row);
            var checkModel = buildCheckModelForRow(row);
            //degroup
            row.show();

            if (checkModel.IsGroupMaster) {
                //set the procedurename instead of the roomname
                row.find('td.fromProcedure').css("background-color", checkModel.FromProcedure_Color);
                row.find('span.fromProcedureInfo').empty();
                row.find('span.fromProcedureInfo').append('<span><b>' + checkModel.FromProcedure_Modality + '</b> ' + checkModel.FromProcedure_Code + '</span>');
            }

            //set grouped
            row.find('input.isGrouped').val(false);
            row.find('input.isGroupMaster').val(false);
            row.find('input.isGroupSlave').val(false);

        });
    }

    $('#GroupChecks').on('change', function () {
        if ($(this).is(':checked')) {
            groupChecks();
        }
        else {
            deGroupChecks();
        }
    });

    function checkCheckGrouping(e) {
        var isGrouped = false;

        $('#checksTable tr').each(function (i, row) {
            var row = $(row);
            var checkModel = {
                IsGrouped: row.find('input.isGrouped').val()
            };

            if (checkModel.IsGrouped == "true") {
                isGrouped = true;
                return false;
            }
        });
        if (isGrouped) {
            $('#GroupChecks').trigger('click');
        }
    }
    function buildCheckModelForRow(row) {
        var checkModel = {
            GUID: row.find('input.checkGUID').val(),
            Checked: row.find('input.checkChecked').is(':checked'),
            Unit: row.find('input.unitValue').val(),
            TextValue: row.find('input.textValue').val(),
            TextValue2: row.find('input.textValue2').val(),
            DateValue: row.find('input.dateValue').val(),
            DropDownValue: row.find('select.dropdownValue').find(':selected').val(),
            CheckedBy_UID: row.find('input.checkByUID').val(),
            Check_UID: row.find('input.checkUID').val(),
            CheckRemarks: row.find('textarea.checkremarkText').text(),
            FromProcedure_UID: row.find('input.checkFromProcedureUID').val(),
            FromOrderProcedure_UID: row.find('input.checkFromOrderProcedureUID').val(),
            FromProcedure_Color: row.find('input.checkFromProcedureColor').val(),
            FromProcedure_Code: row.find('input.checkFromProcedureCode').val(),
            FromProcedure_Modality: row.find('input.checkFromProcedureModality').val(),
            IsGrouped: row.find('input.isGrouped').val(),
            IsGroupMaster: row.find('input.isGroupMaster').val(),
            IsGroupSlave: row.find('input.isGroupSlave').val(),
            Room_UID: row.find('input.roomUID').val(),
            Room_Text: row.find('input.roomText').val()
        };

        return checkModel;
    }

    if (Model.Validated || Model.ReadOnly)
    {
        $('input#btnExportPDF').on('click', function (e) {
            $('#dialogDecision' + viewbagUniquePrefix + ' span.validation').html('');
            $('#dialogDecision' + viewbagUniquePrefix + ' span.validation').hide();
            $('#dialogDecision' + viewbagUniquePrefix + ' #txtFrom').val(Model.GeneralEmailFromAddress);
            $('#dialogDecision' + viewbagUniquePrefix + ' #txtTo').val(Model.ApplicantPrivateEmailAddress);

            //fix for special characters in subject and content
            $('#dialogDecision' + viewbagUniquePrefix + ' #txtContent').html(window.Resources.OrderReport + ' - #' + Model.OrderNumber + ' ' + Model.PatientName);
            $('#dialogDecision' + viewbagUniquePrefix + ' #txtSubject').val($('#dialogDecision' + viewbagUniquePrefix + ' #txtContent').html());

            $('#dialogDecision' + viewbagUniquePrefix).dialog('open');
            $('#dialogDecision' + viewbagUniquePrefix + ' #txtTo').focus();
            $('#dialogDecision' + viewbagUniquePrefix).dialog('open');
        });

        $('#dialogDecision' + viewbagUniquePrefix + ' #btnDownload').on('click', function (e) {
            $('#dialogDecision' + viewbagUniquePrefix).dialog('close');
            window.open('/legacy/Reports/PdfExportValidatedReport?OrderID=' + Model.OrderID+ '&Report_UID=' + Model.PartialReport_UID);
        });

        $('#dialogDecision' + viewbagUniquePrefix + ' #btnSend').on('click', function (e) {
            var from = $('#dialogDecision' + viewbagUniquePrefix + ' #txtFrom').val();
            var to = $('#dialogDecision' + viewbagUniquePrefix + ' #txtTo').val();
            var subject = $('#dialogDecision' + viewbagUniquePrefix + ' #txtSubject').val();
            var content = $('#dialogDecision' + viewbagUniquePrefix + ' #txtContent').val();

            var filter=/\S+@\S+\.\S+/;
            if (filter.test(to)) //good email
            {
                $.ajax({
                    type: 'POST',
                    url: '/legacy/Reports/EmailPdfExportValidatedReport',
                    data: {
                        OrderID: Model.OrderID,
                        Report_UID: Model.PartialReport_UID,
                        From: from,
                        To: to,
                        Subject: subject,
                        Content: content
                    },
                    dataType: 'json',
                    async: false,
                    success:
                        function (data) {
                            if (data.Error) {
                                $('#dialogDecision' + viewbagUniquePrefix + ' span.validation').html(htmlDecode(window.ErrorStrings.ErrorOccured));
                                $('#dialogDecision' + viewbagUniquePrefix + ' span.validation').show();
                                console.log(data.ErrorMessage);
                            }
                            else {
                                $('#dialogDecision' + viewbagUniquePrefix).dialog('close');
                            }
                        }
                });
            }
            else {
                $('#dialogDecision' + viewbagUniquePrefix + ' span.validation').html(htmlDecode(window.ErrorStrings.ErrorValidEmail));
                $('#dialogDecision' + viewbagUniquePrefix + ' span.validation').show();
            }
        });
        $('input#printReport').on('click', function (e) {
            $.ajax({
                type: 'POST',
                data: { Report_UID: Model.PartialReport_UID },
                url: '/legacy/Reports/PrintPartialReport',
                dataType: 'json',
                success: function (data) {
                    if (data.AllOk != true) {
                        alert("Printing failed");
                    }
                }
            });
        });

        $('li#openPreviewTab a').trigger('click');

        $('#btnOKDevalidateScreening' + viewbagUniquePrefix).on('click', function () {
            invalidateRequest();
            $('#divDevalidateScreening').dialog('close');
        });

        $('#btnNOKDevalidateScreening' + viewbagUniquePrefix).on('click', function () {
            $('#divDevalidateScreening').dialog('close');
        });

        function invalidateRequest() {
            $.ajax({
                type: 'POST',
                url: '/legacy/Reports/InvalidatePartialReport',
                data: { Report_UID: Model.PartialReport_UID },
                async: false,
                dataType: 'json',
                success: function (data) {
                    if (data.AllOk) {
                        ReportSharedFunctions.LaunchEmptyPacsIntegration();
                        closeActiveFile(false, true).done(function() {
                            $.ajax({
                                type: 'POST',
                                url: '/legacy/Locks/TryCreateLockFile',
                                data: {
                                    LockType: LockType.Report,
                                    RecordID: $('#lockableRecordID').text()
                                },
                                async: false,
                                dataType: 'json',
                                success:
                                    function (data) {
                                        if (data.Done) {
                                            window.addLocks(new URLSearchParams(window.location.search).get('fc') * 1, data.LockUIDs);
                                        } else if (!data.Done) {
                                            window.showLockedFileDialog(data, $('span#rawUrl').text());
                                        }
                                    }
                            });
                        });
                    }
                }
            });
        }

        $('#btnInvalidateReport').on('click', function (e) {
            $.ajax({
                type: 'POST',
                url: '/legacy/Locks/CheckLockFileBeforeSaving',
                data: { LockType: LockType.Report, RecordID: $('span#lockableRecordID').text() },
                async: false,
                dataType: 'json',
                success:
                    function (data) {
                        if (data.Done) {
                            //check if screening
                            if (screening) {
                                //show popup with invalidatewarning
                                $('#divDevalidateScreening').dialog('open');
                            }
                            else {
                                //no screening, just invalidate
                                invalidateRequest();
                            }
                        }
                        else if (!data.Done) {
                            $('#divNotLockedDialog').dialog('open');
                        }
                    }
            });
        });
    }
    else
    {
        if(userHasSpeechRecognition)
        {
            function performEOLFunctionality(){
                if (EOLSaveOrValidate == 'None') {
                    //Do nothing
                }
                else if (EOLSaveOrValidate == 'Save') {
                    $('#btnSaveAndCloseFile').trigger('click', [true]);
                }
                else if (EOLSaveOrValidate == 'Validate') {
                    $('#btnValidateAndCloseFile').trigger('click', [true]);
                }
                else if (EOLSaveOrValidate == 'Transcribe') {
                    $('#btnSendToTranscription').trigger('click', [true]);
                }
                else if (EOLSaveOrValidate == 'Preliminary') {
                    $('#btnSendToPreliminary').trigger('click', [true]);
                }
            }

            if (useXintax)
            {
                $('#hasXintax').text("true");

                var firstSetupXintax = true;
                var pollXintaxTimeout;
                var firstSetupDate = "";

                try {
                    function launchXintax(e) {
                        launchSpeechXHR = $.ajax({
                            type: 'GET',
                            data: {
                                FirstSetup: firstSetupXintax,
                                OrderNumber: Model.OrderNumber,
                                FirstSetupDate: firstSetupDate
                            },
                            timeout: 15000,
                            url: '/legacy/Reports/LaunchXintaxOnClient',
                            success: function (data) {
                                firstSetupDate = data.FirstSetupDate;
                                if (firstSetupXintax) {
                                    $('#startSpeechRecognition').addClass('disabled');
                                    pollXintaxTimeout = setInterval(function (e) {
                                        launchXintax()
                                    }, 2000);
                                    timeouts.push(pollXintaxTimeout);
                                }
                                if (data.AllOk) {
                                    $('#startSpeechRecognition').removeClass('disabled');
                                    if (overWriteReportWithEmptyXintax) {
                                        tinymce.activeEditor.setContent(data.Text);
                                    }
                                    clearTimeout(pollXintaxTimeout);

                                    performEOLFunctionality();
                                }
                                else if (data.Error) {
                                    $('#startSpeechRecognition').removeClass('disabled');
                                    clearTimeout(pollXintaxTimeout);
                                }
                                firstSetupXintax = false;
                            },
                            error: function (data) {
                                $('#startSpeechRecognition').removeClass('disabled');

                                clearTimeout(pollXintaxTimeout);
                                launchSpeechXHR.abort();
                            }
                        });
                    }
                }
                catch (err) {
                    $('#startSpeechRecognition').removeClass('disabled');
                    launchSpeechXHR.abort();
                }

                $('#startSpeechRecognition').on('click', function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    if (!$(this).hasClass('disabled')) {
                        $(this).addClass('disabled');

                        firstSetupXintax = true;
                        launchXintax();
                    }
                });

                if(startSpeechRecognition && !screening)
                {
                    launchXintax();
                }
            }
            else
            {
                $('#hasG2Speech').text("true");

                $('#startSpeechRecognition').on('click', function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    if (!$(this).hasClass('disabled')) {
                        $(this).addClass('disabled');
                        if (launchSpeechXHR) {
                            launchSpeechXHR.abort();
                        }
                        clearTimeout(window.pollG2Timeout);
                        firstSetupG2 = true;
                        $('#editableContent').val("false");
                        launchG2Speech(true);
                    }
                });

                $('#getSpeechRecognitionText').on('click', function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    e.stopPropagation();

                    $.ajax({
                        type: "GET",
                        url: "/legacy/Reports/GetG2SpeechDocumentOnSaveAndClose",
                        async: false,
                        data: {
                            GUID: reportGUID,
                            Order_UID: Model.OrderID
                        },
                        timeout: 15000,
                        success: function (data) {
                            if (data.AllOk) {
                                if (data.ReportGUID) {
                                    reportGUID = data.ReportGUID;
                                }
                                tinymce.activeEditor.setContent(data.Result);
                                clearTimeout(window.pollG2Timeout);
                                $('#startSpeechRecognition').removeClass('disabled');
                            }
                            else if (data.ErrorG2) {
                                alert(data.ErrorMessage);
                            }
                        }
                    });
                });

                $('#btnOkEditAndDeleteSpeechDocument').on('click', function (e) {
                    closeActiveSpeech().done(function (e) {
                        clearTimeout(window.pollG2Timeout);
                        if (typeof(launchSpeechXHR) !== "undefined") {
                            launchSpeechXHR.abort();
                        }

                        $('#editableContent').val("true");
                        //DELETE SPEECH DOCUMENT
                        $.ajax({
                            type: 'POST',
                            data: {
                                GUID: reportGUID,
                                Order_UID: Model.OrderID
                            },
                            async: false,
                            url: '/legacy/Reports/DeleteG2SpeechDocument',
                            success: function (data) {
                            }
                        });

                        $('#divEditAndDeleteSpeechDocument').dialog('close');
                        tinymce.activeEditor.focus();
                    });
                });

                if(startSpeechRecognition && !screening)
                {
                    if ($('#editableContent').val() == "false") {
                        launchG2Speech();
                    }
                }
            }
        }
    }

    if (toShowScannedOrderOnReport) {
        $('li#openOrderDocumentTab a').trigger('click');
    }

    let ResizeOrderReportFields;

    if (!toShowScannedOrderOnReport || Model.Validated || Model.ReadOnly || Model.Screening) {
        $('#showOrCloseOrderDocuments').hide();

        ResizeOrderReportFields = function(e) {
            $('div#subPageContent').height($('div#content').height() - 20 - $('div#submitBottom').height());
            return false;
        };
    }
    else
    {
        $('#showOrCloseOrderDocuments').on('click', function (e) {
            if ($(this).hasClass('hiddenOrderDocuments')) {
                $(this).removeClass('hiddenOrderDocuments');
                $('#orderReportWrapper').removeClass('orderDocumentsNotShown');
                $('#scannedOrderTab').removeClass('orderDocumentsNotShown');
            }
            else {
                $(this).addClass('hiddenOrderDocuments');
                $('#orderReportWrapper').addClass('orderDocumentsNotShown');
                $('#scannedOrderTab').addClass('orderDocumentsNotShown');
            }
        });

        ResizeOrderReportFields = function(e) {
            $('div#subPageContent').height($('div#content').height() - 20 - $('div#submitBottom').height());

            var maxHeight = $('#subPageContent').height() - ($('#breadcrumb').height() + $('#subPageContent h2').height() + $('#subPageContent div#subContent div.subField').height() + 132);
            $('#scannedOrderTab').css('max-height', maxHeight + 'px');
            $('#orderReportWrapper').css('max-height', maxHeight + 'px');
        }

        $(window).resize(function (e) {
            setTimeout(function () {
                ResizeOrderReportFields();
            }, 300);
        });

        setTimeout(function () {
            ResizeOrderReportFields();
        }, 300);
    }

    var toValidate;
    var toClose;
    var toTranscription;
    var toPreliminary;
    var toTriggerExportFormats;

    function ShowPopupSetCurrentRadiologistAsSupervisor(validated, close, transcription, preliminary, triggerExportFormats) {
        toValidate = validated;
        toClose = close;
        toTranscription = transcription;
        toPreliminary = preliminary;
        toTriggerExportFormats = triggerExportFormats || false;

        $('#divSetCurrentRadiologistAsSupervisor').dialog('open');
    }

    function ShowPopupChooseSupervisor(validated, close, transcription, preliminary, triggerExportFormats) {
        toValidate = validated;
        toClose = close;
        toTranscription = transcription;
        toPreliminary = preliminary;
        toTriggerExportFormats = triggerExportFormats || false;

        $.ajax({
            type: "GET",
            url: "/legacy/Session/GetLastChosenSupervisors",
            async: false,
            success: function (data) {
                if (data.Supervisors.length > 0) {
                    $('#previousChosenSupervisors li.previousChosenSupervisor').remove();
                    for (var i = data.Supervisors.length - 1 ; i >= 0 ; i--) {
                        var li = '<li class="previousChosenSupervisor">- ' + data.Supervisors[i].Name + '<input type="hidden" class="previousChosenSupervisorID" value="' + data.Supervisors[i].ID + '" /></li>';
                        $('#previousChosenSupervisors').append(li);
                    }
                    $('#noPreviousChosenSupervisors').hide();
                }
                else {
                    $('#noPreviousChosenSupervisors').show();
                }
            }
        });

        $('#popupNewChoosenSupervisorID').val("");

        $('#btnChooseSupervisor').attr('disabled', true);

        $('#divChooseSupervisor').dialog('open');
    };

    $('#btnSetCurrentRadiologistAsSupervisorOk').on('click', function (e) {
        var selectedSupervisorID = userRadiologistId;
        $('#divSetCurrentRadiologistAsSupervisor').dialog('close');
        AddChosenSupervisorToSession(selectedSupervisorID);
    });

    $("#btnSetCurrentRadiologistAsSupervisorCancel").on("click", function (e) {
        var selectedSupervisorID = null;
        $("#divSetCurrentRadiologistAsSupervisor").dialog("close");
        ValidateOrSaveAndClose(toValidate, toClose, selectedSupervisorID, toTranscription, toPreliminary, toTriggerExportFormats);
    });

    $('#btnChooseSupervisor').on('click', function (e) {
        var newSupervisorID = $('#popupNewChoosenSupervisorID').val();
        var oldSupervisorID;
        var selectedSupervisorID;

        if (newSupervisorID) {
            selectedSupervisorID = newSupervisorID;
        }
        else {
            oldSupervisorID = $('.previousChosenSupervisor.active').find('.previousChosenSupervisorID').val();
            if (oldSupervisorID) {
                selectedSupervisorID = oldSupervisorID;
            }
        }

        if (selectedSupervisorID) {
            $('#divChooseSupervisor').dialog('close');
            AddChosenSupervisorToSession(selectedSupervisorID);
        }
    });

    function AddChosenSupervisorToSession(selectedSupervisorID) {
        $.ajax({
            type: "POST",
            url: "/legacy/Session/AddChosenSupervisorToSession",
            async: false,
            data: {
                Supervisor_UID: selectedSupervisorID
            },
            success: function (data) {
                ValidateOrSaveAndClose(toValidate, toClose, selectedSupervisorID, toTranscription, toPreliminary, toTriggerExportFormats, Model.OrderProcedures[0].Reviewer_UID);
            }
        });
    }

    $('body').on('click', 'li.previousChosenSupervisor', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        $('li.previousChosenSupervisor').removeClass('active');
        $(this).addClass('active');
        $('#popupChooseSupervisor').val("");
        $('#popupNewChoosenSupervisorID').val("");
        $('#btnChooseSupervisor').prop('disabled', false);
    });


    if (Model.PossibilityToConfirmInvoiceInReport && (Model.InvoiceStatus == 0 || Model.InvoiceStatus == 1)) {
        function checkConfirmAndAdjustInvoice(e) {
            var confirmInvoice = $('#ConfirmInvoiceOnConfirmation').prop('checked');
            if (confirmInvoice) {
                $('#AdjustInvoiceOnConfirmNomenclatures').attr('disabled', false);
                $('#AdjustInvoiceOnConfirmNomenclatures').parent().show();
            }
            else {
                $('#AdjustInvoiceOnConfirmNomenclatures').attr('disabled', true);
                $('#AdjustInvoiceOnConfirmNomenclatures').parent().hide();
            }
        };

        $('#ConfirmInvoiceOnConfirmation').on('change', function (e) {
            checkConfirmAndAdjustInvoice();
        });

        checkConfirmAndAdjustInvoice();
    }

    if(UseImpax6Integration)
    {
        function LaunchImpax6IntegrationAfterAddingOrRemovingProcedures(proceduresIds, clear) {
            $.ajax({
                type: "GET",
                timeout: 10000,
                data: { orderId: Model.OrderID, procedureIds: forOrder_ProcedureUIDs, clear: clear },
                url: '/legacy/Json/LaunchPACSIntegrationAfterAddOrRemoveProcedure'
            });
        }
    }

    if(openPACSIntegration && userHasPACSIntegration && openAllImages)
    {
        $('#showAllImagesLI').show();
    }

    if(openPACSIntegration && userHasPACSIntegration)
    {
        const numbers = Model.ProceduresInOrderReport.InReport.map(orderProcedure => orderProcedure.OrderHasProcedure_UID);
        ReportSharedFunctions.LaunchPacsIntegrationFor(numbers, multiple);
    }

    if(!Model.Validated && !Model.ReadOnly){
        $('.btnCopyPreviousReport').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            const text = $(this).parent().find('textarea#hiddenPreviousContent').val();
            tinyMCE.activeEditor.execCommand('mceInsertContent', false, text);
        });

        $('.btnCopyPreviousReportToG2').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            var text = $(this).parent().find('textarea#hiddenPreviousContent').val();
            var guid = reportGUID;
            $.ajax({
                type: 'POST',
                data: {
                    GUID: guid,
                    ReportContent: htmlEncode($.trim(text))
                },
                async: false,
                url: '/legacy/Reports/CopyReportToG2Speech',
                success: function (data) {
                }
            });
        });
    }

    window.onNavigateForRazor = async () => {
        window.clearRefreshTimeout();
        await window.closeActiveSpeechAsPromise();
    }
}
